const messages = {
  en: {
    translations: {
      newTicketOficial: {
        createAndSend: "Create and Send Template",
      },
      qrcodeModal: {
        title: "Connect to WhatsApp",
        subtitle: "Scan the QR code with your phone to start the session",
        connected: "✅ Successfully connected!",
        generating: "Generating new QR code...",
        step1a: "Open ",
        step1b: " on your phone",
        step2a: "Tap ",
        step2options: "More options ⋮",
        step2b: " or ",
        step2settings: "Settings ⚙",
        step2c: " and select ",
        step2linked: "Linked devices",
        step3a: "Tap ",
        step3link: "Link a device",
        step3b: " and point the camera at this QR code",
        refreshing: "Updating QR code...",
        refreshIn: "QR code updates in {{seconds}}s",
      },
      ticketActionButtons: {
        windowExpiredTooltip: "⚠️ 24h window expired - Send a Template to reopen the conversation",
        sendTemplateTooltip: "Send Template (Official API)",
        sendTemplateExpired: "Send Template (window expired)",
        sendTemplate: "Send Template",
      },
      templateMetaModal: {
        title: "WhatsApp Templates",
        selectedTitle: "Selected Template Details",
        name: "Name",
        content: "Content",
        language: "Language",
        category: "Category",
        body: "BODY",
        required: "Required field",
        back: "Back",
        send: "Send Template",
      },
      signup: {
        title: "Sign Up",
        toasts: {
          success: "User successfully created! Please log in!",
          disabled:
            "User registration is currently disabled. Please try again later.",
          fail: "Error creating user. Please check the provided data.",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
          company: "Organization Name",
          phone: "WhatsApp (Area Code + Number)",
        },
        buttons: {
          submit: "Register",
          login: "Already have an account? Log in!",
        },
      },
      ticketInfo: {
        copyPhone: "Copy Phone",
        quickMessages: "Quick Replies",
        phonecopied: "Phone copied to clipboard!",
        noPhone: "No phone available to copy",
        copyError: "Error copying phone",
      },
      login: {
        title: "Login",
        welcome: "Welcome back",
        loginInstruction: "Enter your credentials to access your account",
        form: {
          email: "Email",
          password: "Password",
          button: "Access",
        },
        buttons: {
          submit: "Enter",
          register: "Sign up",
          forgotPassword: "Forgot my password",
        },
        footer: { rights: "All rights reserved." },
      },
      templateManager: {
        title: "Template Management",
        connection: "Connection",
        search: "Search...",
        syncTooltip: "Sync with Meta",
        sync: "Sync",
        createTemplate: "Create Template",
        noConnection: "No Official API connection found. Add an official connection to manage templates.",
        noTemplates: 'No templates found. Click "Sync" to sync or "Create Template" to create a new one.',
        table: { name: "Name", category: "Category", language: "Language", status: "Status", actions: "Actions" },
        tooltips: { view: "View details", edit: "Edit (recreate template)", delete: "Delete template" },
        categories: { marketing: "Marketing", utility: "Utility", authentication: "Authentication" },
        deleteModal: {
          title: "Delete template",
          body: "This action will delete the template on Meta and locally. Do you want to continue?",
        },
        viewModal: {
          close: "Close",
          title: "Template Details",
          name: "Name",
          language: "Language",
          status: "Status",
          category: "Category",
          components: "Components",
        },
        createModal: {
          title: "Create New Template",
          templateName: "Template Name",
          templateNameHelper: "Lowercase letters, numbers and _ only",
          category: "Category",
          language: "Language",
          header: "Header (optional)",
          headerHelper: "Text displayed at the top of the template",
          body: "Message Body",
          bodyHelper: "Use {1}, {2}, etc. for variables. E.g.: Hello {1}, your order {2} is ready!",
          footer: "Footer (optional)",
          footerHelper: "Small text at the end of the template",
          buttonsTitle: "Buttons (optional - max 3)",
          quickReply: "+ Quick Reply",
          urlButton: "+ Link",
          phoneButton: "+ Phone",
          chipQuickReply: "Quick Reply",
          chipUrl: "Link",
          chipPhone: "Phone",
          textLabel: "Text",
          urlLabel: "URL",
          phoneLabel: "Phone",
          preview: "Preview",
          buttonPlaceholder: "Button {{index}}",
          previewEmpty: "Start typing the body to see the preview here",
          examplesTitle: "Variable Examples (required by Meta)",
          examplesSubtitle: "Meta requires an example value for each variable so reviewers know what content will go there.",
          exampleFor: "example for",
          cancel: "Cancel",
          submit: "Submit for Approval",
          submitting: "Submitting...",
        },
        validation: {
          nameAndBodyRequired: "Template name and message body are required",
          examplesRequired: "You must provide an example for:",
        },
        toast: {
          approved: 'Template "{{name}}" was APPROVED by Meta! 🎉',
          rejected: 'Template "{{name}}" was REJECTED by Meta',
          statusChange: 'Template "{{name}}": {{old}} → {{new}}',
          syncDone: "Sync complete - {{count}} template(s) with status change",
          syncNoChanges: "Templates synced - no status changes",
          tokenExpired: "⚠️ Official API token expired or invalid! Update the Meta access token in the connection settings.",
          submitted: "Template submitted for Meta approval",
          deleted: "Template deleted successfully",
        },
        status: {
          approved: "Approved",
          rejected: "Rejected",
          pending: "Pending",
          paused: "Paused",
        },
      },
      flowBuilder: {
        title: "Flow Editor",
        addNodes: "Add Nodes",
        saveFlow: "Save Flow",
        startOfFlow: "Start of flow",
        intervalLabel: "Interval {{sec}} sec.",
        toast: {
          saved: "Flow saved successfully",
          saveError: "Error saving the flow",
        },
        categories: {
          basic: "Basic",
          content: "Content",
          interaction: "Interaction",
          logic: "Logic",
          system: "System",
          integrations: "Integrations",
        },
        nodes: {
          start: { name: "Start", description: "Starting point of the flow" },
          content: { name: "Content", description: "Send text, image, audio or video" },
          text: { name: "Text", description: "Simple text message" },
          menu: { name: "Menu", description: "Numbered options menu" },
          interactiveMenu: { name: "Interactive API Msg", description: "Buttons and lists (Baileys)" },
          input: { name: "Input", description: "Collect user input" },
          interval: { name: "Interval", description: "Pause execution for a time" },
          random: { name: "Randomizer", description: "Random choice of paths" },
          conditionCompare: { name: "If/Else", description: "Branch flow based on a condition" },
          ticket: { name: "Queues", description: "Manage service queues" },
          tag: { name: "Tags", description: "Add tags to the contact" },
          removeTag: { name: "Remove Tag", description: "Remove tags from the contact" },
          switchFlow: { name: "Switch Flow", description: "Direct to another flow" },
          attendant: { name: "Agent", description: "Transfer to an agent" },
          httpRequest: { name: "HTTP Request", description: "External HTTP request" },
          variable: { name: "Variable", description: "Define global variables" },
          gemini: { name: "Gemini", description: "Integration with Gemini" },
          openai: { name: "OpenAI", description: "Integration with OpenAI" },
          claude: { name: "Claude", description: "Integration with Claude (Anthropic)" },
        },
        aiModal: {
          addTitle: "Add {{provider}} to the flow",
          editTitle: "Edit {{provider}} in the flow",
          buttons: { add: "Add", save: "Save", cancel: "Cancel" },
          basicSettings: "Basic Settings - {{provider}}",
          assistantName: "Assistant Name",
          apiKey: "{{provider}} API Key",
          model: "{{provider}} Model",
          systemPrompt: "System Prompt",
          systemPromptPlaceholder: "Describe how the AI should behave, what information it should collect, how it should respond...",
          sendWelcomeMessage: "Send automatic greeting when activated",
          sendWelcomeMessageHelper: "Sent as soon as this node activates (\"Hello! I'm [assistant name]...\"). Turn it off if your flow already sends its own greeting before reaching here.",
          temperature: "Temperature",
          temperatureHelper: "0 = conservative, 2 = creative",
          maxTokens: "Max Tokens",
          maxTokensHelper: "Maximum response length",
          maxMessages: "Max Messages",
          maxMessagesHelper: "Context history",
          voiceSettings: "Voice Settings (Optional)",
          responseType: "Response Type",
          textOnly: "Text Only",
          voiceKeyAzure: "Voice Key (Azure)",
          voiceKeyPlaceholder: "Azure Speech Service key",
          voiceRegionAzure: "Voice Region (Azure)",
          voiceRegionPlaceholder: "e.g.: brazilsouth",
          flowBehavior: "Flow Behavior",
          flowBehaviorTooltip: "Configure how {{provider}} should behave in the flow",
          operatingMode: "Operating Mode",
          permanentLabel: "Permanent",
          permanentDesc1: "- End flow here",
          permanentDesc2: "The user keeps chatting with the AI until they ask to be transferred or end it",
          temporaryLabel: "Temporary",
          temporaryDesc1: "- Returns to the flow afterward",
          temporaryDesc2: "The AI performs a specific task and then returns to the normal flow",
          temporarySettingsTitle: "⏱️ Temporary Mode Settings",
          temporarySettingsSubtitle: "Configure when the AI should stop and return to the flow",
          maxInteractions: "Maximum Interactions",
          maxInteractionsHelper: "Maximum number of messages before returning to the flow (0 = unlimited)",
          timeoutMinutes: "Timeout (minutes)",
          timeoutHelper: "Time limit before returning to the flow (0 = no limit)",
          continueKeywordsTitle: "Keywords to Continue the Flow",
          continueKeywordsPlaceholder: "Type a keyword",
          addKeywordButton: "Add",
          continueKeywordsHelper: "When the user sends one of these words, the flow will continue automatically",
          objective: "AI Objective",
          objectiveHelper: "Describe what the AI should complete (e.g.: 'Collect name, email and phone')",
          objectivePlaceholder: "E.g.: Collect customer data, Qualify interest, Diagnose issue...",
          autoComplete: "Auto complete when objective is reached",
          autoCompleteHelper: "The AI will automatically check if it completed the objective and return to the flow",
          transferQueueId: "Queue ID (for transfer)",
          transferQueueHelper: "Queue ID to transfer to if the user asks for an agent (0 = do not transfer)",
          validation: {
            tooShort: "Too short!",
            tooLong: "Too long!",
            required: "Required",
            promptRequired: "Describe the training for the Artificial Intelligence",
            invalidModel: "Invalid model",
            modelRequired: "Provide the model",
            minTokens: "Minimum 10 tokens",
            maxTokensLimit: "Maximum {{max}} tokens",
            tokensRequired: "Provide the maximum number of tokens",
            minTemp: "Minimum 0",
            maxTemp: "Maximum 2",
            temperatureRequired: "Provide the temperature",
            apiKeyRequired: "Provide the API Key",
            minMessages: "Minimum 1 message",
            maxMessagesLimit: "Maximum 100 messages",
            messagesRequired: "Provide the maximum number of messages",
            voiceRequired: "Provide the Voice mode",
            voiceKeyRequired: "Voice Key is required for voice synthesis",
            voiceRegionRequired: "Voice Region is required for voice synthesis",
            invalidFlowMode: "Invalid flow mode",
            flowModeRequired: "Select the flow mode",
            minInteractions: "Minimum 1 interaction",
            maxInteractionsLimit: "Maximum 50 interactions",
            minTimeout: "Minimum 1 minute",
            maxTimeoutLimit: "Maximum 60 minutes",
            keywordEmpty: "Keyword cannot be empty",
            keywordsRequired: "At least one keyword is required in temporary mode",
            objectiveRequired: "Objective is required when auto complete is active",
          },
        },
        nodeLabels: {
          startDescription: "This block marks the start of your flow!",
          message: "Message",
          image: "Image",
          audio: "Audio",
          video: "Video",
          recordedNow: "Recorded live",
          audioSent: "Audio sent",
          noHtml5Support: "your browser does not support HTML5",
          seconds: "{{sec}} seconds",
          secondsWord: "seconds",
          numericMenu: "Numbered Menu",
          tag: "Tag",
          tagNotSelected: "Tag not selected",
          removeTagDescription: "Removes the tag from the contact",
          switchFlow: "Switch Flow",
          queue: "Queue",
          globalVariable: "Global Variable",
          variableNameLabel: "Variable name",
          valueLabel: "Value",
          variableValueHelper: "You can use static values or references like ${otherVariable}",
          saved: "Saved!",
          saveVariableButton: "Save variable",
          variableSavedSuccess: "Variable saved successfully!",
          ifElse: "If / Else",
          and: "AND",
          or: "OR",
          true: "True",
          false: "False",
          field: "field",
          value: "value",
          question: "Question:",
          questionNotDefined: "Question not defined",
          variableToStoreAnswer: "Variable to store the answer:",
          variableNotDefined: "Variable not defined",
          valueTooltip: "Value: {{value}}",
          usingVariables: "Using variables: {{vars}}",
          alwaysAsk: "Always ask (even if the variable already exists)",
          buttons: "Buttons",
          bodyPlaceholder: "Message body...",
          buttonDefault: "Button {{number}}",
          selectDefault: "Select",
          itemDefault: "Item {{number}}",
          operators: {
            equals: "==",
            notEquals: "≠",
            contains: "∈ contains",
            notContains: "∉ does not contain",
            containsAny: "∈… contains any",
            greaterThan: ">",
            lessThan: "<",
            greaterOrEqual: "≥",
            lessOrEqual: "≤",
            startsWith: "⊰ starts with",
            endsWith: "⊱ ends with",
            isEmpty: "∅ empty",
            isNotEmpty: "¬∅ not empty",
            regex: ".* regex",
          },
        },
        httpRequest: {
          title: "HTTP Request",
          presetsTitle: "Preconfigured Webhooks",
          selectPreset: "Select preset",
          selectPresetPlaceholder: "Choose a ready-made configuration...",
          systemChip: "SYSTEM",
          usingPreset: "Using preset: ",
          removeButton: "Remove",
          url: "URL",
          urlFromPreset: "URL (from preset)",
          urlHelperPreset: "You can edit the preset's base URL if needed",
          method: "Method",
          testRequest: "Test Request",
          apiResponse: "API Response:",
          viewFullResponse: "View full response",
          showAdvanced: "Show advanced",
          hideAdvanced: "Hide advanced",
          advancedOverridePresetWarning: "Advanced settings may override the preset configuration",
          timeoutMs: "Timeout (ms)",
          queryParams: "Query Parameters",
          key: "Key",
          value: "Value",
          addParam: "Add Parameter",
          headersJson: "Headers (JSON)",
          requestBodyJson: "Request body (JSON)",
          editRequestBody: "Edit request body",
          close: "Close",
          hideMapping: "Hide Response Variables",
          mapResponseVariables: "Map Response Variables",
          mapResponseVariablesTitle: "Map response data to variables",
          path: "Path",
          pathPlaceholder: "e.g.: data.user.id",
          variableName: "Variable name",
          variableNamePlaceholder: "e.g.: userId",
          addVariable: "Add variable",
          usefulTips: "Useful tips:",
          apiResponseAutoSaved: "The full API response is automatically saved in the global variable",
          variableUsageTip: "You can use ${variableName} in the URL and request body to include variable values.",
          fullResponseTitle: "Full API Response",
          configSaved: "Configuration saved!",
          requestError: "Request error",
        },
        modals: {
          text: {
            addTitle: "Add message to the flow",
            editTitle: "Edit flow message",
            add: "Add",
            save: "Save",
            messageLabel: "Message",
          },
          interval: {
            addTitle: "Add an interval to the flow",
            editTitle: "Edit interval",
            add: "Add",
            edit: "Edit",
            secondsLabel: "Time in seconds",
            toastMissingValue: "Add the interval value",
            toastMaxTime: "Maximum time reached: 120 seconds",
          },
          image: {
            addTitle: "Add image to the flow",
            editTitle: "Edit image",
            add: "Add",
            save: "Save",
            captionLabel: "Caption (optional)",
            uploadButton: "Upload image",
            toastAdded: "Image added successfully!",
            toastFileTooBig: "File too large! 2MB maximum",
          },
          audio: {
            addTitle: "Add audio to the flow",
            editTitle: "Edit audio",
            add: "Add",
            save: "Save",
            captionLabel: "Caption (optional)",
            uploadButton: "Upload audio",
            sendAsRecorded: "Send as audio recorded live",
            toastAdded: "Audio added successfully!",
            toastFileTooBig: "File too large! 5MB maximum",
          },
          video: {
            addTitle: "Add video to the flow",
            editTitle: "Edit video",
            add: "Add",
            save: "Save",
            captionLabel: "Caption (optional)",
            uploadButton: "Upload video",
            mp4OnlyWarning: "WARNING! MP4 videos only!",
            toastAdded: "Video added successfully!",
            toastFileTooBig: "File too large! 20MB maximum",
          },
          tag: {
            addTitle: "Add a tag to the flow",
            editTitle: "Edit tag",
            add: "Add",
            edit: "Edit",
            chooseTag: "Choose a tag",
            selectTag: "Select a tag",
            noTagSelected: "No tag selected",
            toastMissing: "Add a tag",
          },
          removeTag: {
            addTitle: "Remove a tag from the flow",
            editTitle: "Edit tag removal",
            add: "Add Removal",
            edit: "Edit",
            chooseTagToRemove: "Choose a tag to remove from the contact",
            description: "This action will remove the selected tag from the contact when the flow runs",
            selectTagToRemove: "Select a tag to remove",
            noTagSelected: "No tag selected",
            toastMissing: "Select a tag to remove",
          },
          switchFlow: {
            addTitle: "Add Flow Switch",
            editTitle: "Edit Flow Switch",
            add: "Add",
            edit: "Edit",
            chooseFlowPlaceholder: "Choose a flow",
          },
          attendant: {
            addTitle: "Add an agent to the flow",
            editTitle: "Edit agent",
            add: "Add",
            edit: "Edit",
            chooseAgent: "Choose an agent",
            selectUser: "Select a user",
            toastMissing: "Add an agent",
          },
          ticket: {
            addTitle: "Add a queue to the flow",
            editTitle: "Edit queue",
            add: "Add",
            edit: "Edit",
            chooseQueue: "Choose the queue you want to transfer to",
            selectConnection: "Select a Connection",
            toastMissing: "Add a queue",
          },
          menu: {
            addTitle: "Add menu to the flow",
            editTitle: "Edit menu",
            add: "Add",
            save: "Save",
            explanationLabel: "Menu explanation message",
            addOption: "Add Option",
            typeOption: "Type {{number}}",
            optionPlaceholder: "Type the option",
          },
          randomizer: {
            addTitle: "Add a randomizer to the flow",
            editTitle: "Edit randomizer",
            add: "Add",
            edit: "Edit",
            toastMissingValue: "Add the interval value",
            toastMaxTime: "Maximum time reached: 120 seconds",
          },
          input: {
            addTitle: "Add input to the flow",
            editTitle: "Edit flow input",
            add: "Add",
            saveChanges: "Save changes",
            questionLabel: "Question",
            questionTooltip: "The question that will be sent to the user. You can include variables using ${variableName}",
            questionInputLabel: "Type the question",
            questionPlaceholder: "E.g.: Hello {{firstName}}, how old are you?",
            flowVariablesLabel: "Flow variables (click to insert):",
            variableNameLabel: "Variable name",
            variableNameTooltip: "Name of the variable where the answer will be stored. Don't use spaces or special characters.",
            variableNamePlaceholder: "E.g.: customer_age",
            variableNameHelper: "The user's answer will be stored in this variable",
            howItWorksTitle: "How it works",
            howItWorksDescription: "This node will send the question to the user and wait for a reply. When the user replies, the value will be stored in the specified variable and the flow will continue to the next node.",
          },
          flowModal: {
            validation: {
              tooShort: "Too short!",
              tooLong: "Too long!",
              nameRequired: "Type a name!",
            },
          },
          interactive: {
            addTitle: "Interactive Message (Baileys)",
            editTitle: "Edit Interactive Message",
            add: "Add",
            save: "Save",
            cancel: "Cancel",
            bodyRequired: "The message body is required!",
            addAtLeastOneOption: "Add at least one option!",
            imageUploadError: "Error uploading image",
            fileTooBig: "File too large! 2MB maximum",
            maxOptionsWarning: "Maximum limit of {{max}} button options!",
            preview: "Preview",
            messageType: "Interactive message type",
            buttonsMax3: "Buttons (max. 3)",
            infoBanner: "Interactive buttons via Baileys (nativeFlowMessage). Works on unofficial connections. Limit of 3 buttons.",
            contentTab: "MESSAGE CONTENT",
            buttonsTab: "BUTTONS ({{count}}/{{max}})",
            bodyLabel: "Message body",
            footerLabel: "Footer (optional)",
            headerImageLabel: "Header image (optional)",
            changeImage: "Change image",
            uploadImage: "Upload image",
            listButtonTextLabel: "List button text",
            listButtonTextHelper: "Text shown on the button that opens the list",
            optionsButtons: "Buttons",
            optionsList: "List options",
            addButton: "Add",
            addAtLeastOneOptionWarning: "⚠ Add at least one option.",
            buttonTextPlaceholder: "Button {{number}} text",
            optionPlaceholder: "Option {{number}}",
          },
          conditionCompare: {
            operators: {
              equals: "Equal to",
              notEquals: "Different from",
              contains: "Contains text",
              notContains: "Does not contain",
              containsAny: "Contains any (,)",
              startsWith: "Starts with",
              endsWith: "Ends with",
              greaterThan: "Greater than",
              lessThan: "Less than",
              greaterOrEqual: "Greater than or equal to",
              lessOrEqual: "Less than or equal to",
              isEmpty: "Is empty",
              isNotEmpty: "Is not empty",
              regex: "Regular expression",
            },
            operatorGroups: {
              Igualdade: "Equality",
              Texto: "Text",
              "Numérico": "Numeric",
              Estado: "State",
              "Avançado": "Advanced",
            },
            categories: {
              "Contato": "Contact",
              "Ticket": "Ticket",
              "Variável Global": "Global Variable",
              "Input Capturado": "Captured Input",
              "Menu": "Menu",
              "HTTP / API": "HTTP / API",
              "API": "API",
            },
            staticVars: {
              contactName: "Contact name",
              contactEmail: "Contact email",
              contactPhone: "Contact phone / number",
              lastMessage: "Last message received",
              ticketId: "Current ticket ID",
              ticketStatus: "Ticket status (open/pending/closed)",
              ticketQueue: "Current ticket queue",
              apiResponse: "Response from the last HTTP request",
            },
            dynamicVarDesc: {
              globalVariableValue: 'Value: "{{value}}"',
              globalVariableGeneric: "Global flow variable",
              inputAnswerFrom: 'Answer to: "{{label}}"',
              inputAnswerGeneric: "Answer captured from the user",
              menuResponse: 'Menu response: "{{message}}"',
              menuOption: 'Option [{{number}}] of the menu: "{{value}}"',
              httpMappedFrom: "Mapped from: {{path}}",
              httpResponseVar: "HTTP response variable",
            },
            titleEdit: "Edit Condition",
            titleNew: "New Condition",
            fieldLabel: "Variable / Field",
            fieldPlaceholder: "Type $ to see available variables",
            fieldHelper: "Type $ to autocomplete flow variables",
            insertVariableTooltip: "Insert variable using the picker",
            conditionTypeLabel: "Condition type",
            comparisonValueLabel: "Comparison value",
            commaValuesLabel: "Comma-separated values",
            commaPlaceholder: "yes, y, si, 1",
            regexHelper: "E.g.: ^[0-9]{11}$ — JavaScript regular expression",
            containsAnyHelper: "Any token from the list triggers True",
            valueHelper: "Fixed value or variable with $",
            and: "AND",
            or: "OR",
            addCondition: "Add condition",
            logicAllTrue: "ALL conditions",
            logicAnyTrue: "ANY condition",
            logicPrefix: "Logic: True if",
            logicSuffix: "are satisfied",
            quickTipsTitle: "💡 Quick tips",
            tip1: "Contains any (,): separate tokens with commas → yes, y, si, 1",
            tip2: "Regex: use a JS expression → ^[0-9]{11}$ to validate a document",
            tip3: "Use ${variable} in any field to reference dynamic values",
            saveError: "An error occurred while saving. Please try again.",
            conditionFieldRequired: 'Condition {{number}}: the "Variable / Field" field is required',
            conditionValueRequired: 'Condition {{number}}: the "Comparison value" field is required',
            cancel: "Cancel",
            saving: "Saving...",
            saveChanges: "Save changes",
            add: "Add",
            selectVariable: "Select variable",
            varsFoundInFlow: "{{count}} variable(s) found in the flow",
            addVarNodesHint: "Add Global Variable or Input nodes for dynamic variables",
            searchVariablePlaceholder: "Search variable...",
            noVariableFound: "No variable found",
            flowVariablesTitle: "Flow variables",
          },
          singleBlock: {
            addTitle: "Add content to the flow",
            editTitle: "Edit content",
            add: "Add",
            save: "Save",
            toastEmptyMessage: "Empty message fields!",
            toastIntervalRange: "Interval cannot be 0 or greater than 120!",
            toastImageTooBig: "File too large! 2MB maximum",
            toastAudioTooBig: "File too large! 5MB maximum",
            toastVideoTooBig: "File too large! 20MB maximum",
            toastDocumentTooBig: "File too large! 10MB maximum",
            toastContentAdded: "Content added successfully!",
            toastDeleteEmptyCards: "Delete the empty cards (Image, Audio and Video)",
            documentLabel: "Document",
            uploadDocument: "Upload Document",
            viewDocument: "View Document",
            availableVariables: "Available variables",
            uploadingContent: "Uploading files and creating content...",
            variableLabels: {
              firstName: "First Name",
              name: "Name",
              userName: "Agent",
              ms: "Greeting",
              protocol: "Protocol",
              date: "Date",
              hour: "Time",
              ticket_id: "Ticket #",
              queue: "Sector",
              connection: "Connection",
              phoneNumber: "Phone",
              email: "Email",
              kanban: "Kanban",
            },
          },
        },
      },
      flowBuilderList: {
        title: "Conversation Flows ({{count}})",
        searchPlaceholder: "Search flows...",
        importButton: "Import (.zip)",
        newFlowButton: "New Flow",
        emptyTitleSearch: "No flow found",
        emptyTitleNoFlows: "No flow created yet",
        emptyDescSearch: "Try using other search terms",
        emptyDescNoFlows: "Create your first conversation flow to automate support",
        createFirstFlow: "Create First Flow",
        createFlowAriaLabel: "Create flow",
        menu: {
          export: "Export (.zip)",
          open: "Open flow",
          edit: "Edit flow",
          delete: "Delete flow",
        },
        deleteTitle: 'Delete flow "{{name}}"?',
        deleteBody: "This action cannot be undone. All related integrations will be lost.",
        duplicateTitle: 'Duplicate flow "{{name}}"?',
        duplicateBody: "A copy of the flow will be created for you to edit.",
        toast: {
          activated: "activated",
          deactivated: "deactivated",
          toggled: "Flow {{status}} successfully",
          deleted: "Flow deleted successfully",
          duplicated: "Flow duplicated successfully",
          invalidZip: "Please select a ZIP file (.zip)",
          imported: "Flow imported successfully",
        },
      },
      floup: {
        page: {
          title: "Follow UP - Flow Templates",
          newTemplate: "New Template",
          editTemplate: "Edit Template",
          steps: "{{count}} steps",
          active: "Active",
          inactive: "Inactive",
          tooltips: { edit: "Edit", duplicate: "Duplicate", delete: "Delete" },
          saveError: "Error saving the Follow UP. Check the console for details.",
          deleteError: "Error deleting the Follow UP. Check the console for details.",
          uploadError: "Error uploading the file. Check the console for details.",
          defaultName: "this floup",
          templateTypes: {
            client: { title: "Template for Clients", description: "Automated flow for existing clients", defaultMessage: "Hello! How can we help you today?" },
            lead: { title: "Template for Leads", description: "Nurturing flow for new leads", defaultMessage: "Hello! Welcome! We have a special offer for you." },
            custom: { title: "Custom Template", description: "Create your own flow with specific conditions" },
          },
          basicInfo: "Basic Information",
          templateName: "Template Name",
          templateTypeLabel: "Template Type",
          templateTypeOptions: { client: "Client", lead: "Lead", custom: "Custom" },
          description: "Description",
          triggerCondition: "Trigger Condition",
          triggerConditionHelp: "Define when this Follow UP should be triggered. Once triggered, all steps will run sequentially until the stop conditions are met.",
          condition: "Condition",
          conditionOptions: { queue: "System queue", tag: "System tag", firstClientInteraction: "Client's first interaction", firstAttendantInteraction: "Agent's first interaction" },
          queue: "Queue",
          selectQueue: "Select queue",
          tag: "Tag",
          selectTag: "Select tag",
          conditionDescription: "Condition description",
          conditionDescriptionPlaceholder: "E.g.: Client sent first message",
          stopControls: "Flow Stop Controls",
          stopConditions: {
            anyMessage: "1. If the Contact replies with any message",
            keyword: "2. If the Contact replies with a Keyword",
            keywordLabel: "Keyword",
            keywordPlaceholder: "E.g.: STOP, CANCEL, EXIT",
            ticketClosed: "3. If the Ticket is Closed",
          },
          stepsHeading: "Flow Steps",
          addStep: "Add Step",
          cancel: "Cancel",
          saveTemplate: "Save Template",
          step: {
            title: "Step {{order}}",
            emptyMessage: "Empty message",
            attachment: "Attachment",
            message: "Message",
            charsCount: "{{count}}/500 characters",
            value: "Value",
            timeUnit: "Time Unit",
            timeUnits: { minutes: "Minutes", hours: "Hours", days: "Days", weeks: "Weeks", months: "Months", years: "Years" },
            sendAfter: "Send after {{value}} {{unit}}",
            attachmentLink: "Attachment/Link",
            linkOption: "Link",
            uploadOption: "Upload",
            pasteUrl: "Paste the URL here",
            removeLink: "Remove link",
            removeMedia: "Remove file",
            chooseFile: "Choose File",
            uploading: "Uploading {{fileName}}...",
            videoPlayerTitle: "Video Player",
            videoNotSupported: "Your browser does not support the video element.",
            removeStep: "Remove Step",
          },
          preview: {
            title: "Message Preview",
            attachment: "Attachment",
            hint: "The attachment icon will appear here",
          },
          deleteDialog: {
            title: "Confirm Deletion",
            body: 'Are you sure you want to delete the Follow UP "{{name}}"? This action cannot be undone and all associated media will be permanently deleted.',
            cancel: "Cancel",
            confirm: "Delete",
          },
        },
        selector: {
          stopSuccess: "Follow UP stopped successfully",
          stopButton: "Stop Follow UP",
          nextSteps: "Next steps:",
          active: "Active",
          selectLabel: "Select Follow UP",
          chooseTemplate: "Choose template...",
          infoTooltip: "Information about Follow UP",
          stageLabel: "{{name}} - Stage {{current}} of {{total}}",
          nextRun: "Next run: {{date}}",
          activeShort: "Follow UP active",
          noneActive: "No active Follow UP",
          noneActiveHelper: "This contact is not currently in any Follow UP",
          infoDialog: {
            title: "About the Follow UP System",
            body1: "<strong>Follow UP</strong> lets you create message flows and assign them to a contact or ticket for automatic execution.",
            body2: "Select an active template to start. You can stop it at any time.",
            close: "Got it",
          },
        },
        dashboard: {
          title: "Follow UP Dashboard by Stage",
          refresh: "Refresh",
          error: "Error",
          next: "Next: {{date}}",
          recentError: "⚠️ Recent error",
          stage: "Stage {{order}}",
          noMessage: "No message",
          noContactsInStage: "No contacts at this stage",
          selectLabel: "Follow UP",
          inactive: "(Inactive)",
          stagesCount: "Stages",
          contactsCount: "Contacts",
          search: "Search",
          channel: "Channel",
          allChannels: "All",
          selectFloup: "Select a Follow UP to view the stages",
          noData: "No data found for this Follow UP",
          noStages: "No stages found",
        },
      },
      companies: {
        title: "Register Company",
        form: {
          name: "Company Name",
          plan: "Plan",
          token: "Token",
          submit: "Register",
          success: "Company successfully created!",
        },
      },

      auth: {
        toasts: {
          success: "Login successful!",
        },
        dueDate: {
          expiration: "Your subscription expires in",
          days: "days!",
          day: "day!",
          expirationToday: "Your subscription expires today!",
        },
        token: "Token",
      },
      pendingTicketOverlay: {
        title: "Conversation Locked",
        subtitle: "This ticket is waiting to be accepted. Accept the conversation to view and reply to the customer's messages.",
        statusWaiting: "Status: Waiting",
        defaultContactName: "Contact",
        accepting: "Accepting...",
        acceptConversation: "Accept Conversation",
        warning: "🚫 You cannot view the messages before accepting the ticket",
      },
      dashboard: {
        filters: "Filters",
        filter: "FILTER ",
        hideFilters: "Hide Filters",
        showFilters: "Show Filters",
        satisfactionSurvey: "Satisfaction Survey",
        attendances: "Attendances",
        errorFetchingTickets: "Error fetching ticket information",
        tabs: {
          indicators: "Indicators",
          assessments: "NPS",
          attendants: "Agents",
        },
        charts: {
          perDay: {
            title: "Attendances today: ",
          },
        },
        cards: {
          inAttendance: "In Attendance",
          waiting: "Waiting",
          activeAttendants: "Active Agents",
          finalized: "Finalized",
          newContacts: "New Contacts",
          totalReceivedMessages: "Received Messages",
          totalSentMessages: "Sent Messages",
          averageServiceTime: "Average Service Time",
          averageWaitingTime: "Average Waiting Time",
          status: "Status (Current)",
          activeTickets: "Active Tickets",
          passiveTickets: "Passive Tickets",
          groups: "Groups",
        },
        users: {
          name: "Name",
          numberAppointments: "Number of Attendances",
          statusNow: "Current Status",
          totalCallsUser: "Total Attendances per User",
          totalAttendances: "Total Attendances",
        },
        date: {
          initialDate: "Start Date",
          finalDate: "End Date",
        },
        licence: {
          available: "Available until",
        },
        assessments: {
          totalCalls: "Total Attendances",
          callsWaitRating: "Attendances Waiting for Rating",
          callsWithoutRating: "Attendances Without Rating",
          ratedCalls: "Rated Attendances",
          evaluationIndex: "Evaluation Index",
          score: "Score",
          prosecutors: "Promoters",
          neutral: "Neutral",
          detractors: "Detractors",
        },
      },
      reports: {
        title: "Research Reports",
        operator: "Operator",
        period: "Period",
        until: "Until",
        date: "Date",
        reportTitle: "Reports",
        calls: "Attendances",
        search: "Surveys",
        durationCalls: "Attendance Duration",
        grupoSessions: "Group Attendances",
        groupTicketsReports: {
          timezone: "America/Sao_Paulo",
          msgToast: "Generating compressed report, please wait.",
          errorToast: "Error generating report",
          back: "Back",
          groupServiceReport: "Group Attendance Report",
          loading: "Loading...",
          contact: "Contact",
          dateOpen: "Opening Date",
          dateLastUpdated: "Last Update Date",
          agent: "Agent",
          agentClosed: "Agent who closed",
          waitingAssistance: "Waiting for Service",
          process: "In Service",
        },
        researchReports: {
          response: "Response",
          active: "(Active)",
          inactive: "(Inactive)",
          quantity: "Quantity",
          percentage: "Percentage",
          title: "Research Reports",
          activeSearch: "Active Survey",
          inactiveSearch: "Inactive Survey",
        },
        ticketDurationDetail: {
          msgToast: "Generating compressed report, please wait.",
          title: "Attendance Duration Report",
          startService: "Start of Attendance",
          lastUpdated: "Last Updated",
          lastAgent: "Last Agent",
          durationFinished: "Duration After Closing",
        },
        ticketDuration: {
          title: "Attendance Duration Report",
          contact: "Contact",
          open: "Open",
          pending: "Pending",
          finished: "Finished",
          durationFinished: "Duration of Finished Attendances",
          durationAfterFinished: "Duration After Closing",
          actions: "Actions",
        },
        ticketReports: {
          msgToast: "Generating compressed report, please wait.",
          title: "Attendance Report",
        },
        exportExcel: {
          title: "Attendance Reports",
          startDate: "Start date",
          endDate: "End date",
          notInformed: "Not informed",
          columns: {
            id: "ID",
            connection: "Connection",
            contact: "Contact",
            user: "User",
            queue: "Queue",
            status: "Status",
            lastMessage: "Last Message",
            openDate: "Open Date",
            openTime: "Open Time",
            closeDate: "Close Date",
            closeTime: "Close Time",
            supportTime: "Support Time",
            nps: "NPS",
          },
        },
        pdf: {
          title: "List of Completed Attendances",
          exportTitle: "List of Completed Group Attendances",
        },
      },
      todo: {
        newTask: "New Task",
        add: "Add",
        task: "Tasks",
      },
      contactImportWpModal: {
        title: "Export Contacts to Excel",
        buttons: {
          downloadModel: "Download Excel template for import",
          closed: "Close",
          import: "Select Excel file to import Contacts",
        },
      },
      connections: {
        preDeleteTitle: "Before deleting",
        preDeleteBody: "Have you already transferred the tickets from this connection to another? If not, we recommend transferring them before deleting.",
        preDeleteNo: "Not yet",
        preDeleteYes: "Yes, already transferred",
        title: "Connections",
        waitConnection: "Please wait... Your connections will be restarted!",
        newConnection: "New Connection",
        restartConnections: "Restart Connections",
        callSupport: "Call Support",
        connectYourServiceChannelsToReceiveMessagesAndStartConversationsWithYourCustomers:
          " Connect your service channels to receive messages and start conversations with your customers.",
        client: "Client",
        connectedConnections: "Connected connections",
        disconnectedConnections: "Disconnected connections",
        totalConnections: "Total connections",
        total: "Total",
        connections: " Connections:",
        toasts: {
          deleted: "Connection successfully deleted!",
          closedimported:
            "Closing imported tickets, please wait a few moments.",
        },
        confirmationModal: {
          closedImportedTitle: "Close imported tickets",
          closedImportedMessage:
            "If you confirm, all imported tickets will be closed.",
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? This action cannot be undone.",
          disconnectTitle: "Disconnect",
          disconnectMessage:
            "Are you sure? You will need to scan the QR Code again.",
        },
        buttons: {
          add: "Add Connection",
          disconnect: "Disconnect",
          tryAgain: "Try Again",
          qrcode: "QR CODE",
          newQr: "New QR CODE",
          closedImported: "Close all imported tickets",
          preparing: "Preparing messages for import",
          importing: "Importing WhatsApp Messages",
          processed: "Processed",
          in: "of",
          connecting: "Connecting",
        },
        typography: {
          processed: "Processed",
          in: "of",
          date: "Message Date",
        },
        toolTips: {
          disconnected: {
            title: "Failed to start WhatsApp session",
            content:
              "Make sure your phone is connected to the internet and try again, or request a new QR Code.",
          },
          qrcode: {
            title: "Waiting for QR Code scan",
            content:
              "Click the 'QR CODE' button and scan the QR Code with your phone to start the session.",
          },
          connected: {
            title: "Connection established!",
          },
          timeout: {
            title: "Connection with the phone was lost",
            content:
              "Make sure your phone is connected to the internet and WhatsApp is open, or click 'Disconnect' to get a new QR Code.",
          },
        },
        table: {
          name: "Name",
          status: "Status",
          lastUpdate: "Last Update",
          default: "Default",
          actions: "Actions",
          session: "Session",
          number: "WhatsApp Number",
          color: "Color",
          receiveComments: "Receive Comments",
        },
        receiveComments: {
          enabled: "Comment receiving enabled",
          disabled: "Comment receiving disabled",
          tooltip: {
            enabled: "Comments are being received. Click to disable.",
            disabled: "Comments are not being received. Click to enable.",
          },
        },
      },
      showTicketOpenModal: {
        title: {
          header: "Existing Attendance",
        },
        form: {
          message: "This contact is already being attended to:",
          user: "Agent",
          queue: "Queue",
          messageWait:
            "This contact is already waiting for service. Check the Waiting tab!",
        },
        buttons: {
          close: "Close",
        },
      },
      showTicketLogModal: {
        title: {
          header: "Logs",
        },
        options: {
          create: "Ticket created.",
          chatBot: "ChatBot started.",
          queue: " - Queue assigned.",
          open: " started the service.",
          access: "accessed the ticket.",
          transfered: "transferred the ticket.",
          receivedTransfer: "received the transferred ticket.",
          pending: "returned to the queue.",
          closed: "closed the ticket.",
          reopen: "reopened the ticket.",
          redirect: "- redirected",
          clientClosed: "Client closed the ticket.",
        },
      },
      whatsappModal: {
        title: {
          add: "Add Connection",
          edit: "Edit Connection",
        },
        tabs: {
          general: "General",
          messages: "Messages",
          assessments: "NPS",
          integrations: "Integrations",
          schedules: "Business Hours",
          chatbot: "Chatbot",
          flowbuilder: "Default Flow",
        },
        sections: {
          tokenIntegration: "Token for external integration",
          flowWelcome: "Welcome flow",
          flowWelcomeSubtitle: "This flow is triggered only for new contacts — people not in your contact list who sent a message.",
          flowDefault: "Default response flow",
          flowDefaultSubtitle: "The default response is sent for any input that doesn't match a keyword. WARNING! It will trigger even if the ticket is already closed.",
          disabled: "Disabled",
        },
        form: {
          importOldMessagesEnable: "Import messages from device",
          importOldMessages: "Start date of import",
          importRecentMessages: "End date of import",
          importOldMessagesGroups: "Import group messages",
          closedTicketsPostImported: "Close tickets after import",
          name: "Name",
          queueRedirection: "Queue Redirection",
          queueRedirectionDesc:
            "Select a queue for contacts without an assigned queue",
          default: "Default",
          group: "Allow groups",
          timeSendQueue: "Time in minutes to redirect to queue",
          importAlert:
            "WARNING: Saving will terminate your connection. You will need to scan the QR Code again to import messages.",
          groupAsTicket: "Treat groups as ticket",
          timeCreateNewTicket: "Create a new ticket after X minutes",
          maxUseBotQueues: "Send bot X times",
          maxUseInactiveTime: "Send inactivity flow X times",
          timeUseBotQueues: "Send bot in X minutes",
          timeToReturnQueue: "Time to return to queue in minutes",
          timeAwaitActiveFlow: "Time to wait for active flow",
          expiresTicket: "Close open chats after X minutes",
          expiresTicketNPS: "Close chats awaiting evaluation after X minutes",
          maxUseBotQueuesNPS: "Max times evaluation is sent",
          closeLastMessageOptions1: "From agent/client",
          closeLastMessageOptions2: "From agent only",
          outOfHoursMessage: "Out-of-hours message",
          greetingMessage: "Greeting message",
          complationMessage: "Completion message",
          lgpdLinkPrivacy: "Privacy policy link",
          lgpdMessage: "LGPD greeting message",
          lgpdDeletedMessages: "Obfuscate messages deleted by contact",
          lgpdSendMessage: "Always request contact confirmation",
          ratingMessage: "Evaluation message - Scale must be from 0 to 10",
          token: "Token for external integration",
          sendIdQueue: "Queue",
          inactiveMessage: "Inactivity warning message",
          timeInactiveMessage: "Time in minutes to send inactivity warning",
          flowInactiveTime: "Time in minutes to send inactivity flow",
          whenExpiresTicket: "Close chats when the last message is",
          expiresInactiveMessage: "Inactivity closure message",
          prompt: "Prompt",
          collectiveVacationEnd: "End date",
          collectiveVacationStart: "Start date",
          collectiveVacationMessage: "Collective vacation message",
          queueIdImportMessages: "Queue for message import",
          isOficial: "Official",
          phone_number_id: "Phone Number ID",
          waba_id: "WABA ID",
          send_token: "Sending token",
          business_id: "Business ID",
          phone_number: "Phone number",
          triggerIntegrationOnClose: "Trigger Integration on Ticket Close",
          enableIntegration: "Habilited Integration",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        menuItem: {
          enabled: "Enabled",
          disabled: "Disabled",
          minutes: "minutes",
        },
        success: "Connection saved successfully.",
        errorSendQueue:
          "You set a redirection time but no queue was selected. Both fields are required.",
        errorExpiresNPS: "A timeout must be set for NPS evaluation.",
        errorRatingMessage: "An evaluation message must be provided for NPS.",
      },
      qrCode: {
        message: "Scan the QR Code to start the session",
      },
      contacts: {
        title: "Contacts",
        toasts: {
          deleted: "Contact successfully deleted!",
        },
        searchPlaceholder: "Search...",
        conversationFlows: " Conversation Flows",
        addFlow: "Add Flow",
        editFlow: "Edit Flow ",
        confirmationModal: {
          deleteTitle: "Delete",
          importTitlte: "Import Contacts",
          exportContact: "Export Contacts",
          deleteMessage:
            "Are you sure you want to delete this contact? All related attendances will be lost.",
          blockContact: "Are you sure you want to block this contact?",
          unblockContact: "Are you sure you want to unblock this contact?",
          importMessage: "Do you want to import all contacts from the phone?",
          importChat: "Import Chats",
          wantImport: "Do you want to import all chats from the phone?",
        },
        buttons: {
          import: "Import Contacts",
          add: "Add Contact",
          export: "Export Contact",
        },
        loading: "Loading...",
        loadMore: "Load More",
        table: {
          name: "Name",
          whatsapp: "Connection",
          email: "Email",
          actions: "Actions",
          lastMessage: "Last Message",
          wallet: "Wallet",
        },
        menu: {
          importYourPhone: "Import from default device",
          importToExcel: "Import/Export from Excel",
          importexport: "IMPORT / EXPORT ",
        },
      },
      forwardMessage: {
        text: "Forwarded",
      },
      forwardMessageModal: {
        title: "Forward Message",
        buttons: {
          ok: "Forward",
        },
      },
      promptModal: {
        tabs: {
          general: "General",
          aiModel: "AI & Model",
          messages: "Messages",
          voice: "Voice",
        },
        form: {
          name: "Name",
          prompt: "Prompt",
          voice: "Voice",
          max_tokens: "Maximum Tokens in Response",
          temperature: "Temperature",
          apikey: "API Key",
          max_messages: "Maximum Messages in History",
          voiceKey: "Voice API Key",
          voiceRegion: "Voice Region",
          provider: "Provider",
          model: "Model",
          modelRecommended: "(Recommended)",
          modelEconomic: "(Economical)",
          trainingLabel: "Training / System Prompt",
          trainingPlaceholder: "E.g.: You are a virtual assistant for company X. Your role is to assist customers, answer questions about products and services...",
          temperatureHelper: "0 = precise, 1 = creative",
          maxTokensHelper: "Max. response length",
          maxMessagesHelper: "Memory context",
          greetingMessage: "Initial Greeting Message",
          greetingPlaceholder: "E.g.: Hello {{firstName}}! 👋 I'm the company's virtual assistant. How can I help you?",
          greetingHelper: "First message sent to the customer when the AI takes over. Leave empty for the AI to start directly.",
          transferMessage: "Transfer Message",
          transferPlaceholder: "E.g.: Understood! I'll transfer you to a human agent. Please wait a moment! 😊",
          transferHelper: "Message sent when the customer requests to talk to an agent.",
          errorMessage: "Error Message",
          errorPlaceholder: "E.g.: Sorry, I'm experiencing technical difficulties right now. Please try again later.",
          errorHelper: "Message sent when an error occurs in the AI.",
          transferKeywordsTitle: "🔑 Transfer Keywords",
          transferKeywords: "Transfer Keywords",
          transferKeywordsPlaceholder: "E.g.: talk to a human, I want an agent, exit ai, really need help",
          transferKeywordsHelper: "Words or phrases separated by commas. When the customer types one of them, they'll be transferred to an agent. The system's default words remain active.",
          voiceMode: "Response Mode",
          voiceText: "Text",
          voiceKeyAzure: "Voice Key (Azure)",
          voiceRegionAzure: "Voice Region (Azure)",
          voiceOnlyOpenAiWarning: "⚠️ Voice responses only work with the OpenAI provider. With Gemini, the response will always be text.",
        },
        variables: {
          availableInPrompt: "💡 Variables available in the prompt:",
          availableInMessages: "💡 Variables available in the messages:",
          contactName: "Contact name",
          firstName: "First name",
          queueName: "Queue name",
          agentName: "Agent name",
          currentDate: "Current date",
          currentHour: "Current time",
          greeting: "Greeting (Good morning...)",
        },
        validation: {
          tooShort: "Too short!",
          tooLong: "Too long!",
          required: "Required",
          promptRequired: "Describe the training for the Artificial Intelligence",
          voiceRequired: "Provide the Voice mode",
          maxTokensRequired: "Provide the maximum number of tokens",
          temperatureRequired: "Provide the temperature",
          apikeyRequired: "Provide the API Key",
          queueRequired: "Provide the queue",
          maxMessagesRequired: "Provide the maximum number of messages",
          missingQueue: "Provide the sector",
        },
        success: "Prompt saved successfully!",
        title: {
          add: "Add Prompt",
          edit: "Edit Prompt",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Name",
          queue: "Sector/Queue",
          max_tokens: "Max Tokens in Response",
          actions: "Actions",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? This action cannot be undone!",
        },
        buttons: {
          add: "Add Prompt",
        },
        noPermission: "This company doesn't have permission to access this page. We're redirecting you.",
      },
      contactModal: {
        title: {
          add: "Add Contact",
          edit: "Edit Contact",
        },
        form: {
          mainInfo: "Contact Data",
          extraInfo: "Additional Information",
          name: "Name",
          number: "WhatsApp Number",
          email: "Email",
          extraName: "Field Name",
          extraValue: "Value",
          chatBotContact: "Disable Chatbot",
          termsLGDP: "LGPD Terms accepted on:",
          whatsapp: "Origin Connection:",
        },
        buttons: {
          addExtraInfo: "Add Information",
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Contact saved successfully.",
        walletLinked: "Contact linked to your wallet successfully!",
        walletError: "User has no associated queues",
        saveFirst: "Contact must be saved first",
      },
      wallets: {
        title: "Contact Wallets",
        searchPlaceholder: "Search contacts...",
        filterByUser: "Filter by User",
        allUsers: "All users",
        contact: "Contact",
        user: "User",
        queue: "Queue",
        phone: "Phone",
        email: "Email",
        actions: "Actions",
        editWallet: "Edit Wallet",
        selectUser: "Select User",
        selectQueue: "Select Queue",
        selectUserAndQueue: "Select a user and queue",
        cancel: "Cancel",
        save: "Save",
        confirmDeleteTitle: "Confirm Deletion",
        confirmDeleteMessage:
          "Are you sure you want to remove this contact from the wallet?",
        deleteSuccess: "Contact removed from wallet successfully!",
        updateSuccess: "Wallet updated successfully!",
      },
      queueModal: {
        title: {
          queueData: "Queue Data",
          text: "Business Hours",
          add: "Add Queue",
          edit: "Edit Queue",
          confirmationDelete:
            "Are you sure? All integration options will be deleted.",
        },
        form: {
          name: "Name",
          color: "Color",
          orderQueue: "Queue Order (Bot)",
          rotate: "Rotation",
          timeRotate: "Rotation Time",
          typeRandomMode: "Rotation Type",
          greetingMessage: "Greeting Message",
          complationMessage: "Completion Message",
          outOfHoursMessage: "Out-of-Hours Message",
          token: "Token",
          integrationId: "Integration",
          fileListId: "File List",
          closeTicket: "Close Ticket",
          queueType: "Menu Type",
          message: "Return Message",
          queue: "Transfer Queue",
          integration: "Integration",
          file: "File List",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        bot: {
          title: "Options",
          toolTipTitle: "Add options to build a chatbot",
          toolTip:
            "If there is only one option, it will be automatically chosen, and the bot will respond with the message and proceed",
          selectOption: "Select an Option",
          text: "Text",
          attendent: "Agent",
          queue: "Queue",
          integration: "Integration",
          file: "File",
          toolTipMessageTitle:
            "Message is required to proceed to the next level",
          toolTipMessageContent:
            "Message is required to proceed to the next level",
          selectUser: "Select a User",
          selectQueue: "Select a Queue",
          selectIntegration: "Select an Integration",
          addOptions: "Add Options",
        },
        serviceHours: {
          dayWeek: "Day of the Week",
          startTimeA: "Start Time - Shift A",
          endTimeA: "End Time - Shift A",
          startTimeB: "Start Time - Shift B",
          endTimeB: "End Time - Shift B",
          monday: "Monday",
          tuesday: "Tuesday",
          wednesday: "Wednesday",
          thursday: "Thursday",
          friday: "Friday",
          saturday: "Saturday",
          sunday: "Sunday",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Add Project",
          edit: "Edit Project",
        },
        form: {
          id: "ID",
          type: "Type",
          name: "Name",
          projectName: "Project Name",
          language: "Language",
          jsonContent: "JSON Content",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Expiration time in minutes",
          typebotKeywordFinish: "Keyword to finish the ticket",
          typebotKeywordRestart: "Keyword to restart the flow",
          typebotRestartMessage: "Message when restarting the conversation",
          typebotUnknownMessage: "Invalid option message",
          typebotDelayMessage: "Delay (ms) between messages",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
          test: "Test Bot",
        },
        messages: {
          testSuccess: "Integration tested successfully!",
          addSuccess: "Integration added successfully.",
          editSuccess: "Integration edited successfully.",
        },
      },
      userModal: {
        warning: "To import messages, you must scan the QR Code again!",
        title: {
          add: "Add User",
          edit: "Edit User",
          updateImage: "Update Image",
          removeImage: "Delete Image",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
          farewellMessage: "Farewell Message",
          profile: "Profile",
          startWork: "Work Start Time",
          endWork: "Work End Time",
          whatsapp: "Default Connection",
          allTicketEnable: "Enabled",
          allTicketDisable: "Disabled",
          allTicket: "View Tickets Without Queue",
          allowGroup: "Allow Groups",
          defaultMenuOpen: "Open",
          defaultMenuClosed: "Closed",
          defaultMenu: "Default Menu",
          defaultTheme: "Default Theme",
          defaultThemeDark: "Dark",
          defaultThemeLight: "Light",
          allHistoric: "View Conversations from Other Queues",
          allHistoricEnabled: "Enabled",
          allHistoricDisabled: "Disabled",
          allUserChat: "View Other Users' Conversations",
          userClosePendingTicket: "Allow Closing Pending Tickets",
          showDashboard: "View Dashboard",
          allowRealTime: "View Real-Time Panel",
          allowConnections: "Allow Actions on Connections",
          showContacts: "View Contacts",
          showCampaign: "View Campaigns",
          allowSeeMessagesInPendingTickets: "Allow viewing pending tickets",
          showReturnQueueButton: "Show return to queue button",
          showTransferTicketButton: "Show transfer ticket button",
          showFlow: "View Automations",
        },
        tabs: {
          general: "General",
          permissions: "Permissions",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
          addImage: "Add Image",
          editImage: "Edit Image",
        },
        success: "User saved successfully.",
      },
      companyModal: {
        title: {
          add: "Add Company",
          edit: "Edit Company",
        },
        form: {
          name: "Name",
          email: "Email",
          passwordDefault: "Password",
          numberAttendants: "Users",
          numberConections: "Connections",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Company saved successfully.",
      },
      scheduleModal: {
        title: {
          add: "New Schedule",
          edit: "Edit Schedule",
          message: "Message",
        },
        form: {
          body: "Message",
          contact: "Contact",
          sendAt: "Scheduled Date",
          sentAt: "Sent Date",
          assinar: "Send Signature",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
          addSchedule: "Add Schedule",
        },
        success: "Schedule saved successfully.",
      },
      tagModal: {
        title: {
          add: "New Tag",
          edit: "Edit Tag",
          addKanban: "New Lane",
          editKanban: "Edit Lane",
          backToKanban: "BACK TO KANBAN",
        },
        form: {
          name: "Name",
          color: "Color",
          timeLane: "Time in minutes to redirect to lane",
          nextLaneId: "Lane",
          greetingMessageLane: "Lane Greeting Message",
          mediaFiles: "Media",
          rollbackLaneId: "Return to Lane after resuming attendance",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Tag saved successfully.",
        successKanban: "Lane saved successfully.",
      },
      fileModal: {
        title: {
          add: "Add File List",
          edit: "Edit File List",
        },
        buttons: {
          okAdd: "Save",
          okEdit: "Edit",
          cancel: "Cancel",
          fileOptions: "Add File",
        },
        form: {
          name: "File List Name",
          message: "List Details",
          fileOptions: "File List",
          extraName: "Message to send with file",
          extraValue: "Option Value",
        },
        success: "File list saved successfully!",
      },
      chat: {
        noTicketMessage: "Select a ticket to start chatting.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop: "⬇️ DRAG AND DROP FILES BELOW ⬇️",
          titleFileList: "File List",
        },
      },
      chatInternal: {
        new: "New group",
        modal: {
          conversation: "Conversation",
          title: "Title",
          filterUsers: "Filter by Users",
          cancel: "Close",
          save: "Save",
        },
        modalDelete: {
          title: "Delete Conversation",
          message: "This action cannot be undone, confirm?",
        },
      },
      ticketsManager: {
        questionCloseTicket: "DO YOU WANT TO CLOSE ALL TICKETS?",
        yes: "YES",
        not: "NO",
        buttons: {
          newTicket: "New",
          resolveAll: "Resolve All",
          close: "Close",
          new: "New",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Queues",
      },
      tickets: {
        messageHidden: "Hidden message",
        inbox: {
          closedAllTickets: "Close all tickets?",
          closedAll: "Close All",
          newTicket: "New Ticket",
          yes: "YES",
          no: "NO",
          open: "Open",
          resolverd: "Resolved",
        },
        toasts: {
          deleted: "The attendance you were handling has been deleted.",
        },
        notification: {
          message: "Message from",
        },
        tabs: {
          open: { title: "Open" },
          closed: { title: "Resolved" },
          search: { title: "Search" },
        },
        search: {
          placeholder: "Search attendance and messages",
          filterConections: "Filter by Connection",
          filterConectionsOptions: {
            open: "Open",
            closed: "Closed",
            pending: "Pending",
          },
          filterUsers: "Filter by Users",
          filterContacts: "Filter by Contacts",
          ticketsPerPage: "Tickets per page",
        },
        buttons: {
          showAll: "All",
          returnQueue: "Return to Queue",
          scredule: "Schedule",
          deleteTicket: "Delete Ticket",
        },
        closedTicket: {
          closedMessage: "Close Ticket With Farewell Message",
          closedNotMessage: "Close Ticket Without Farewell Message",
        },
      },
      transferTicketModal: {
        title: "Transfer Ticket",
        fieldLabel: "Type to search for users",
        fieldQueueLabel: "Transfer to Queue",
        fieldQueuePlaceholder: "Select a queue",
        fieldWhatsapp: "Select a WhatsApp",
        noOptions: "No users found with that name",
        msgTransfer: "Notes - internal message, will not be sent to the client",
        buttons: {
          ok: "Transfer",
          cancel: "Cancel",
        },
      },
      chatInternal: {
        new: "New group",
        modal: {
          conversation: "Conversation",
          title: "Title",
          filterUsers: "Filter by Users",
          cancel: "Close",
          save: "Save",
        },
        modalDelete: {
          title: "Delete Conversation",
          message: "This action cannot be undone, confirm?",
        },
      },
      ticketsList: {
        called: "Call",
        today: "Today",
        missedCall: "Missed voice/video call at",
        pendingHeader: "Waiting",
        assignedHeader: "In Attendance",
        groupingHeader: "Groups",
        noTicketsTitle: "Nothing here!",
        noTicketsMessage:
          "No attendances found with this status or search term",
        noQueue: "No Queue",
        buttons: {
          accept: "Accept",
          cancel: "Cancel",
          start: "Start",
          closed: "Close",
          reopen: "Reopen",
          transfer: "Transfer",
          ignore: "Ignore",
          exportAsPDF: "Export to PDF",
          kanbanActions: "Kanban Options",
        },
        acceptModal: {
          title: "Accept Chat",
          queue: "Select Sector",
        },
      },
      newTicketModal: {
        title: "Create Ticket",
        fieldLabel: "Type to search for a contact",
        add: "Add",
        selectQueue: "Select a queue",
        selectConnection: "Select a Connection",
        queueRequired: "Select a queue",
        otherUser: "Other user",
        buttons: {
          ok: "Save",
          cancel: "Cancel",
        },
      },
      SendContactModal: {
        title: "Send Contact",
        fieldLabel: "Type to search for contact",
        add: "Add",
        buttons: {
          ok: "Send",
          cancel: "Cancel",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Connections",
          chatsTempoReal: "Real-Time Panel",
          tickets: "Attendances",
          quickMessages: "Quick Replies",
          contacts: "Contacts",
          wallets: "Wallets",
          queues: "Queues & Chatbot",
          tags: "Tags",
          administration: "Administration",
          companies: "Companies",
          users: "Users",
          birthdaySettings: "Birthday Settings",
          settings: "Settings",
          files: "File Lists",
          helps: "Help Center",
          messagesAPI: "API",
          schedules: "Schedules",
          campaigns: "Campaigns",
          annoucements: "Announcements",
          chats: "Internal Chat",
          financeiro: "Financial",
          queueIntegration: "Integrations",
          version: "Version",
          kanban: "Kanban",
          prompts: "Talk.AI",
          allConnections: "Manage Connections",
          reports: "Reports",
          management: "Management",
          callHistorical: "Call History",
          automations: "Automations",
          campaignFlow: "Campaign Flow",
          conversationFlow: "Conversation Flow",
          followUpTemplates: "Follow UP (Templates)",
        },
        appBar: {
          user: {
            profile: "Profile",
            logout: "Logout",
            message: "Hello",
            messageEnd: "welcome to",
            active: "Active until",
            goodMorning: "Hi,",
            myName: "my name is",
            continuity: "and I will continue your service.",
            virtualAssistant: "Virtual Assistant",
            token: "Invalid token, please contact the platform administrator.",
          },
          message: {
            location: "Location",
            contact: "Contact",
          },
          notRegister: "No records found",
          refresh: "Refresh",
        },
      },
      languages: {
        undefined: "Language",
        "pt-BR": "Portuguese",
        es: "Spanish",
        en: "English",
        tr: "Turkish",
        ar: "Arabic",
      },
      messagesAPI: {
        title: "API",
        toSend: "TO SEND",
        textMessage: {
          number: "Number",
          body: "Message",
          token: "Registered Token",
          userId: "User/Agent ID",
          queueId: "Queue ID",
        },
        mediaMessage: {
          number: "Number",
          body: "File Name",
          media: "File",
          token: "Registered Token",
        },
        API: {
          title: "Message Sending Documentation",
          methods: {
            title: "Sending Methods",
            messagesText: "Text Messages",
            messagesMidia: "Media Messages",
          },
          instructions: {
            title: "Instructions",
            comments: "Important Notes",
            comments1:
              "Before sending messages, it is necessary to register the token linked to the connection that will send the messages. <br />To register, access the 'Connections' menu, click the edit button on the connection, and insert the token in the appropriate field.",
            comments2:
              "The sending number must not have a mask or special characters and must be composed of:",
            codeCountry: "Country Code",
            code: "Area Code (DDD)",
            number: "Phone Number",
          },
          text: {
            title: "1. Text Messages",
            instructions:
              "Below is the list of required information to send text messages:",
          },
          media: {
            title: "2. Media Messages",
            instructions:
              "Below is the list of required information to send media messages:",
          },
        },
      },
      notifications: {
        noTickets: "No notifications.",
        messageHidden: "Hidden message",
        newMessage: "New message from",
      },
      triggerFlowModal: {
        title: "Trigger Flow",
        description:
          "Select a flow to run on this ticket. The ticket will be changed to 'chatbot' status during execution.",
        selectFlow: "Choose a flow",
        selectedFlow: "Selected flow",
        flowId: "Flow ID",
        noFlows: "No active flows found",
        cancel: "Cancel",
        trigger: "Trigger Flow",
        triggering: "Triggering...",
        success: "Flow triggered successfully!",
        error: "Error triggering flow",
      },
      quickMessages: {
        title: "Quick Replies",
        searchPlaceholder: "Search...",
        noAttachment: "No attachment",
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action is irreversible! Do you want to proceed?",
        },
        buttons: {
          add: "Add",
          attach: "Attach File",
          cancel: "Cancel",
          edit: "Edit",
        },
        toasts: {
          success: "Shortcut added successfully!",
          deleted: "Shortcut removed successfully!",
        },
        dialog: {
          title: "Quick Message",
          shortcode: "Shortcut",
          message: "Response",
          save: "Save",
          cancel: "Cancel",
          general: "General",
          geral: "Allow Editing",
          add: "Add",
          edit: "Edit",
          visao: "Allow Viewing",
        },
        table: {
          shortcode: "Shortcut",
          message: "Message",
          actions: "Actions",
          mediaName: "File Name",
          status: "Status",
        },
      },
      contactLists: {
        title: "Contact Lists",
        table: {
          name: "Name",
          contacts: "Contacts",
          actions: "Actions",
        },
        buttons: {
          add: "New List",
        },
        dialog: {
          name: "Name",
          company: "Company",
          okEdit: "Edit",
          okAdd: "Add",
          add: "Add",
          edit: "Edit",
          cancel: "Cancel",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
        },
        toasts: {
          deleted: "Record deleted successfully.",
        },
      },
      contactListItems: {
        title: "Contacts",
        searchPlaceholder: "Search",
        buttons: {
          add: "New",
          lists: "Lists",
          import: "Import",
        },
        dialog: {
          name: "Name",
          number: "Number",
          whatsapp: "WhatsApp",
          email: "Email",
          okEdit: "Edit",
          okAdd: "Add",
          add: "Add",
          edit: "Edit",
          cancel: "Cancel",
        },
        table: {
          name: "Name",
          number: "Number",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Actions",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
          importMessage:
            "Do you want to import the contacts from this spreadsheet?",
          importTitlte: "Import",
        },
        toasts: {
          deleted: "Record deleted successfully.",
        },
      },
      kanban: {
        title: "Kanban",
        searchPlaceholder: "Search",
        subMenus: {
          list: "Board",
          tags: "Lanes",
        },
      },
      templatePreview: {
        fillVariables: "Fill in the variables to see the personalized message:",
        variable: "Variable",
        variablePlaceholder: "E.g.: Contact name",
        hideFields: "Hide fields",
        editVariables: "Edit variables",
        image: "Image",
        video: "Video",
        document: "Document",
        attachAbove: "Attach {{type}} above",
      },
      campaigns: {
        title: "Campaigns",
        noPermission: "This company does not have permission to access this page. You will be redirected.",
        searchPlaceholder: "Search",
        subMenus: {
          list: "Listing",
          listContacts: "Contact List",
          settings: "Settings",
        },
        settings: {
          randomInterval: "Random Sending Interval",
          noBreak: "No Interval",
          intervalGapAfter: "Longer interval after",
          undefined: "Undefined",
          messages: "messages",
          laggerTriggerRange: "Larger Sending Interval",
          addVar: "Add Variable",
          save: "Save",
          close: "Close",
          add: "Add",
          shortcut: "Shortcut",
          content: "Content",
        },
        buttons: {
          add: "New Campaign",
          contactLists: "Contact Lists",
        },
        table: {
          name: "Name",
          whatsapp: "Connection",
          contactList: "Contact List",
          option: "None",
          disabled: "Disabled",
          enabled: "Enabled",
          status: "Status",
          scheduledAt: "Scheduled",
          completedAt: "Completed",
          confirmation: "Confirmation",
          actions: "Actions",
          recurrence: "Recurrence",
          nextExecution: "Next Execution",
          finished: "Finished",
          single: "One-time",
          listRemoved: "List removed",
          connectionRemoved: "Removed",
          notCompleted: "Not completed",
          totalCount: "Total: {{count}} campaign(s)",
          rowsPerPage: "Rows per page:",
        },
        status: {
          INATIVA: "Inactive",
          PROGRAMADA: "Scheduled",
          EM_ANDAMENTO: "In Progress",
          CANCELADA: "Cancelled",
          FINALIZADA: "Finished",
        },
        recurrenceTypes: {
          DIARIA: "Daily",
          SEMANAL: "Weekly",
          QUINZENAL: "Biweekly",
          MENSAL: "Monthly",
        },
        tooltips: {
          recurring: "Recurring Campaign",
          stop: "Stop Campaign",
          restart: "Restart Campaign",
          stopRecurrence: "Stop Recurrence",
          report: "Report",
          edit: "Edit",
          delete: "Delete",
        },
        filters: {
          status: "Status",
          recurrence: "Recurrence",
          all: "All",
          withRecurrence: "With recurrence",
          withoutRecurrence: "Without recurrence",
        },
        confirmModal: {
          stopRecurrenceTitle: "Stop Recurrence",
          stopRecurrenceBody: "Are you sure you want to stop the recurrence of this campaign? The current campaign will continue running, but there will be no more future executions.",
        },
        toasts: {
          recurrenceStopped: "Recurrence stopped successfully",
          total: "Total: {{count}} campaign(s)",
        },
        dialog: {
          new: "New Campaign",
          update: "Edit Campaign",
          readonly: "View Only",
          help: "Use variables like {name}, {number}, {email}, or define custom variables.",
          form: {
            name: "Name",
            message1: "Message 1",
            message2: "Message 2",
            message3: "Message 3",
            message4: "Message 4",
            message5: "Message 5",
            confirmationMessage1: "Confirmation Message 1",
            confirmationMessage2: "Confirmation Message 2",
            confirmationMessage3: "Confirmation Message 3",
            confirmationMessage4: "Confirmation Message 4",
            confirmationMessage5: "Confirmation Message 5",
            messagePlaceholder: "Message content",
            whatsapp: "Connection",
            status: "Status",
            scheduledAt: "Schedule",
            confirmation: "Confirmation",
            contactList: "Contact List",
            tagList: "Tags",
            statusTicket: "Ticket Status",
            openTicketStatus: "Open",
            pendingTicketStatus: "Pending",
            closedTicketStatus: "Closed",
            enabledOpenTicket: "Enabled",
            disabledOpenTicket: "Disabled",
            openTicket: "Open Ticket",
          },
          buttons: {
            add: "Add",
            edit: "Update",
            okadd: "Ok",
            cancel: "Cancel Sending",
            restart: "Restart Sending",
            close: "Close",
            attach: "Attach File",
          },
          tabs: {
            campaign: "Campaign",
            contactLists: "📋 Contact Lists",
            settings: "⚙️ Settings",
          },
          recurrence: {
            sectionTitle: "Recurrence Settings",
            enable: "Enable recurrence",
            typeLabel: "Recurrence Type",
            intervalLabel: "Interval",
            daysOfWeek: "Days of the Week",
            dayOfMonth: "Day of Month",
            dayOfMonthHint: "Specific day of the month (1-31)",
            endDate: "End Date (optional)",
            endDateHint: "Leave empty for infinite recurrence",
            maxExecutions: "Max Executions (optional)",
            maxExecutionsHint: "Leave empty for infinite recurrence",
            showPreview: "View Next Executions",
            hidePreview: "Hide Next Executions",
            previewTitle: "Next 5 Executions:",
            executionLabel: "Execution",
            days: {
              sunday: "Sunday",
              monday: "Monday",
              tuesday: "Tuesday",
              wednesday: "Wednesday",
              thursday: "Thursday",
              friday: "Friday",
              saturday: "Saturday",
            },
            types: {
              minutely: "Per Minute",
              hourly: "Per Hour",
              daily: "Daily",
              weekly: "Weekly",
              biweekly: "Biweekly",
              monthly: "Monthly",
              yearly: "Yearly",
            },
            intervalHint: {
              minutely: "minute(s)",
              hourly: "hour(s)",
              daily: "day(s)",
              weekly: "week(s)",
              biweekly: "fortnight(s)",
              monthly: "month(s)",
              yearly: "year(s)",
            },
          },
          contactSection: {
            title: "📋 Campaign Contact List",
            subtitle: "Select a list created in the",
            subtitleTab: "📋 Contact Lists",
            subtitleEnd: " tab. The list defines who will receive the messages of this campaign.",
            selectLabel: "Contact List",
            noList: "No list selected",
            tagLabel: "Filter by Tag (optional)",
            noTag: "No tag filter",
            changeList: "Change list → Go to Contact Lists",
            createList: "+ Create or select a list in the Contact Lists tab",
            contacts: "contacts",
          },
          message: {
            sectionTitle: "Campaign Message",
            attachMedia: "Attach Media",
            officialApiNotice: "For Official API, use the selected template. The message field and media attachment are not available.",
            selectApprovedTemplate: "Select an approved template for campaigns via Official API.",
            noApprovedTemplate: "No approved template found. Create a template before sending.",
            officialRequired: "Required for Official API. Messages without a template fail outside the 24h window.",
            previewTitle: "Message Preview",
            previewSubtitle: "See how the message will appear in WhatsApp",
            previewContact: "Contact",
            previewEmpty: "Type a message to\nsee the preview here",
            inputPlaceholder: "Type a message",
            variablesHint: "Available variables",
          },
          shootingSettings: {
            title: "Sending Intervals",
            subtitle: "Configure time intervals between sends for this campaign to avoid blocks.",
            antiBan: "Anti-Ban",
            antiBanSubtitle: "Humanizes sending to reduce block risk",
            pauseEvery: "Extra pause every N msgs",
            pauseDuration: "Extra pause duration",
            disabled: "Disabled",
            everyN: "Every {{n}} messages",
            saveSuccess: "Settings saved successfully!",
            jitter: "Random variation (jitter)",
            seconds: "seconds",
            minute: "1 minute",
            minutes: "{{n}} minutes",
          },
          variables: {
            name: "Name",
            number: "Number",
            email: "Email",
            greeting: "Greeting",
            protocol: "Protocol",
            firstName: "First Name",
            agent: "Agent",
          },
          templateLabel: "Template *",
          officialApiLabel: "Official API",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
        },
        toasts: {
          success: "Operation completed successfully.",
          cancel: "Campaign canceled.",
          restart: "Campaign restarted.",
          deleted: "Record deleted successfully.",
        },
      },
      campaignContactSelector: {
        contacts: "contacts",
        excelTemplate: "Excel Template",
        importExcel: "Import Excel",
        importContacts: "Import Contacts",
        searchContact: "Search contact...",
        searchByNameOrNumber: "Search by name or number...",
        searchList: "Search list...",
        searchSystemContacts: "Search System Contacts",
        noContactsInList: "No contacts in this list yet.",
        importViaExcelOrWhatsApp: "Import via Excel or from WhatsApp using the buttons above.",
        name: "Name",
        number: "Number",
        email: "Email",
        loadMore: "Load more",
        listSelectedForCampaign: "✓ List selected for this campaign",
        selectThisListForCampaign: "Select this list for the campaign",
        backToCampaign: "Back to Campaign →",
        newContactList: "New Contact List",
        newListExcel: "New List + Excel",
        simpleList: "Simple List",
        contactLists: "Contact Lists",
        headerSubtitle: "Create lists, import contacts and select the list to be used in this campaign.",
        selectedListLabel: "Selected list",
        contactsWillBeUsed: "contacts — this list will be used in the campaign",
        remove: "Remove",
        noListCreated: "No list created yet.",
        clickNewListToStart: "Click \"New List\" to get started.",
        selectedBadge: "Selected",
        steps: {
          nameList: "Name list",
          importContacts: "Import contacts",
        },
        nameListDescription: "Give a name to identify this contact list.",
        listNameLabel: "List name",
        nameMinChars: "The name must have at least 2 characters.",
        listNamePlaceholder: "E.g.: VIP Clients, November Prospects...",
        characters: "characters",
        listCreatedImportOptional: "List \"{{name}}\" created! Now import the contacts (optional).",
        dragExcelOrClick: "Drag the Excel file here or click to select",
        acceptedFormats: "Accepted formats: .xls, .xlsx",
        downloadTemplate: "📥 Download template spreadsheet (.xlsx)",
        close: "Close",
        cancel: "Cancel",
        skipImport: "Skip import",
        creating: "Creating...",
        createList: "Create List →",
        sending: "Sending...",
        selected: "selected",
        addingToList: "Adding to list",
        filterByTag: "Filter by tag:",
        clear: "Clear",
        loadingTags: "Loading tags...",
        noTagsAvailable: "No tags available.",
        selectAll: "Select all",
        displayed: "displayed",
        noContactFound: "No contact found.",
        trySearchOther: "Try searching by another name or number.",
        adding: "Adding...",
        addToList: "Add to list",
        confirmDeleteList: "Delete the list \"{{name}}\"?",
        tooltips: {
          alreadySelected: "List already selected",
          selectForCampaign: "Select for the campaign",
          searchSystemContacts: "Search system contacts for this list",
          editList: "Edit list",
          deleteList: "Delete list",
        },
        toasts: {
          contactsAdded: "{{count}} contact(s) added to the list \"{{name}}\"!",
          listRemoved: "List removed successfully",
          importStarted: "Import started! Contacts will be loaded shortly.",
          selectWhatsAppFirst: "Select a WhatsApp connection in the campaign before importing.",
          whatsappImported: "WhatsApp contacts imported successfully!",
          listCreated: "List \"{{name}}\" created successfully!",
          invalidFormat: "Invalid format. Use only .xls or .xlsx files",
          fileSent: "File sent! Contacts will be loaded shortly.",
          listSelectedSuccess: "List \"{{name}}\" selected for the campaign!",
        },
      },
      campaignReport: {
        title: "Campaign Report",
        inactive: "Inactive",
        scheduled: "Scheduled",
        process: "In Progress",
        cancelled: "Canceled",
        finished: "Completed",
        campaign: "Campaign",
        validContacts: "Valid Contacts",
        confirmationsRequested: "Confirmations Requested",
        confirmations: "Confirmations",
        deliver: "Delivered",
        processed: "Processed",
        failed: "Failed",
        pending: "Pending",
        of: "of",
        connection: "Connection",
        contactLists: "Contact List",
        schedule: "Schedule",
        conclusion: "Conclusion",
        fetchError: "Error fetching report data",
        backButton: "Back",
        deliveryStatus: "Delivery Status",
        messagesSent: "Messages Sent",
        uniqueRecipients: "Unique Recipients",
        messagesDelivered: "Messages Delivered",
        whatsappConnection: "WhatsApp Connection",
        notSpecified: "Not specified",
        tagUsed: "Tag Used",
        notScheduled: "Not scheduled",
        notCompleted: "Not completed",
        messageDetails: "Message Details",
        exportExcel: "Export Excel",
        recipient: "Recipient",
        message: "Message",
        sentAt: "Sent at",
        deliveredAt: "Delivered at",
        chartDelivered: "Delivered",
        chartPending: "Pending",
        chartFailed: "Failed",
        statusDelivered: "Delivered",
        statusPending: "Pending",
        statusFailed: "Failed",
        statusUnknown: "Unknown",
        loading: "Loading...",
        noMessagesFound: "No messages found",
        rowsPerPage: "Rows per page:",
        group: "Group",
        excelGenerating: "Generating Excel report, please wait...",
        excelLoadingData: "Loading data...",
        excelNoData: "No data found to export",
        excelSuccess: "Excel report generated successfully!",
        excelError: "Error generating Excel report",
        shippingLoadError: "Error loading shipping data",
        excelReportTitle: "Campaign Report",
        excelCampaignLabel: "Campaign:",
        excelDateLabel: "Generation Date:",
      },
      announcements: {
        title: "Announcements",
        searchPlaceholder: "Search",
        active: "Active",
        inactive: "Inactive",
        buttons: {
          add: "New Announcement",
          contactLists: "Announcement Lists",
        },
        table: {
          priority: "Priority",
          title: "Title",
          text: "Text",
          mediaName: "File",
          status: "Status",
          actions: "Actions",
        },
        dialog: {
          edit: "Edit Announcement",
          add: "New Announcement",
          update: "Edit Announcement",
          readonly: "View Only",
          form: {
            priority: "Priority",
            title: "Title",
            text: "Text",
            mediaPath: "File",
            status: "Status",
            high: "High",
            medium: "Medium",
            low: "Low",
            active: "Active",
            inactive: "Inactive",
          },
          buttons: {
            add: "Add",
            edit: "Update",
            okadd: "Ok",
            cancel: "Cancel",
            close: "Close",
            attach: "Attach File",
          },
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
        },
        toasts: {
          success: "Operation completed successfully.",
          deleted: "Record deleted successfully.",
        },
      },
      campaignsConfig: {
        title: "Campaign Settings",
      },
      queues: {
        title: "Queues & Chatbot",
        table: {
          name: "Name",
          color: "Color",
          greeting: "Greeting Message",
          orderQueue: "Queue Order (Bot)",
          actions: "Actions",
          ID: "ID",
        },
        buttons: {
          add: "Add Queue",
        },
        toasts: {
          success: "Queue saved successfully.",
          deleted: "Queue deleted successfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "Are you sure? This action cannot be undone! Attendances from this queue will still exist but will no longer be assigned to a queue.",
        },
      },
      queue: {
        queueData: "Queue Data",
      },
      queueSelect: {
        inputLabel: "Queues",
        inputLabelRO: "Read-Only Queues",
        withoutQueue: "No Queue",
      },
      reports: {
        title: "Attendance Reports",
        startDate: "Start date ",
        endDate: "End date",

        table: {
          id: "Ticket",
          user: "User",
          dateOpen: "Opening Date",
          dateClose: "Closing Date",
          NPS: "NPS",
          status: "Status",
          whatsapp: "Connection",
          queue: "Queue",
          actions: "Actions",
          lastMessage: "Last Message",
          contact: "Customer",
          supportTime: "Attendance Time",
        },
        buttons: {
          filter: "Apply Filter",
          onlyRated: "Only Rated",
        },
        searchPlaceholder: "Search...",
      },
      queueIntegration: {
        title: "Integrations",
        table: {
          id: "ID",
          type: "Type",
          name: "Name",
          projectName: "Project Name",
          language: "Language",
          lastUpdate: "Last Update",
          actions: "Actions",
        },
        buttons: {
          add: "Add Project",
        },
        searchPlaceholder: "Search...",
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "Are you sure? This action cannot be undone and will be removed from linked queues and connections.",
        },
      },
      users: {
        title: "Users",
        table: {
          status: "Status",
          name: "Name",
          email: "Email",
          profile: "Profile",
          startWork: "Work Start Time",
          endWork: "Work End Time",
          actions: "Actions",
          ID: "ID",
        },
        buttons: {
          add: "Add User",
        },
        toasts: {
          deleted: "User deleted successfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "All user data will be lost. Open tickets for this user will be moved to the queue.",
        },
      },
      compaies: {
        title: "Companies",
        table: {
          ID: "ID",
          status: "Active",
          name: "Name",
          email: "Email",
          password: "Password",
          phone: "Phone",
          plan: "Plan",
          active: "Active",
          numberAttendants: "Agents",
          numberConections: "Connections",
          value: "Value",
          namePlan: "Plan Name",
          numberQueues: "Queues",
          useCampaigns: "Campaigns",
          useExternalApi: "REST API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "WhatsApp",
          useInternalChat: "Internal Chat",
          useSchedules: "Scheduling",
          createdAt: "Created At",
          dueDate: "Expiration Date",
          lastLogin: "Last Login",
          folderSize: "Folder size ",
          totalFiles: " Total Files",
          lastUpdate: "Last update",
          actions: "Actions",
          money: "$",
          yes: "Yes",
          no: "No",
          document: "CNPJ/CPF",
          recurrence: "Recurrence",
          monthly: "Monthly",
          bimonthly: "Bimonthly",
          quarterly: "Quarterly",
          semester: "Semiannual",
          yearly: "Annual",
          clear: "Clear",
          delete: "Delete",
          user: "User",
          save: "Save",
          generateInvoice: "Generate Invoice",
        },
        buttons: {
          add: "Add Company",
        },
        toasts: {
          deleted: "Company deleted successfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "All company data will be lost. Open tickets for users in this company will be moved to the queue.",
        },
      },
      plans: {
        form: {
          name: "Name",
          users: "Users",
          connections: "Connections",
          campaigns: "Campaigns",
          schedules: "Schedules",
          enabled: "Enabled",
          disabled: "Disabled",
          clear: "Cancel",
          delete: "Delete",
          save: "Save",
          yes: "Yes",
          no: "No",
          money: "$",
          public: "Public",
          trial: "Trial",
          trialDays: "Trial Days",
        },
      },
      helps: {
        title: "Help Center",
        settings: {
          codeVideo: "Video Code",
          description: "Description",
          clear: "Clear",
          delete: "Delete",
          save: "Save",
        },
      },
      schedules: {
        title: "Schedules",
        date: "Date",
        time: "Time",
        event: "Event",
        allDay: "All Day",
        week: "Week",
        work_week: "Work Week",
        day: "Day",
        month: "Month",
        previous: "Previous",
        next: "Next",
        yesterday: "Yesterday",
        tomorrow: "Tomorrow",
        today: "Today",
        agenda: "Agenda",
        noEventsInRange: "No events in this range.",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Schedule?",
          deleteMessage: "This action cannot be undone.",
        },
        table: {
          contact: "Contact",
          body: "Message",
          sendAt: "Scheduled Date",
          sentAt: "Sent Date",
          status: "Status",
          actions: "Actions",
        },
        buttons: {
          add: "New Schedule",
        },
        toasts: {
          deleted: "Schedule deleted successfully.",
        },
      },
      tags: {
        title: "Tags",
        addColumns: "+ ADD COLUMNS",
        search: "SEARCH",
        seeTicket: "SEE TICKET",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Tag?",
          deleteMessage: "This action cannot be undone.",
        },
        table: {
          id: "ID",
          name: "Name",
          kanban: "Kanban",
          color: "Color",
          tickets: "Tag Records",
          contacts: "Contacts",
          actions: "Actions",
        },
        buttons: {
          add: "New Tag",
        },
        toasts: {
          deleted: "Tag deleted successfully.",
        },
      },
      tagsKanban: {
        title: "Lanes",
        laneDefault: "Open",
        backToKanban: "BACK TO KANBAN",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Lane?",
          deleteMessage: "This action cannot be undone.",
        },
        table: {
          name: "Name",
          color: "Color",
          tickets: "Tickets",
          actions: "Actions",
        },
        buttons: {
          add: "New Lane",
        },
        toasts: {
          deleted: "Lane deleted successfully.",
        },
      },
      files: {
        title: "File Lists",
        table: {
          name: "Name",
          contacts: "Contacts",
          actions: "Action",
        },
        toasts: {
          deleted: "File list deleted successfully!",
          deletedAll: "All file lists were deleted successfully!",
        },
        buttons: {
          add: "Add",
          deleteAll: "Delete All",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteAllTitle: "Delete All",
          deleteMessage: "Are you sure you want to delete this list?",
          deleteAllMessage: "Are you sure you want to delete all lists?",
        },
      },
      settings: {
        success: "Settings saved successfully.",
        title: "Settings",
        tabs: {
          options: "Options",
          plans: "Plans",
          helps: "Help",
          companies: "Companies",
        },
        settings: {
          userCreation: {
            name: "User Creation",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
          tabs: {
            options: "Options",
            schedules: "Schedules",
            plans: "Plans",
            help: "Help",
          },
          options: {
            disabled: "Disabled",
            enabled: "Enabled",
            updating: "Updating...",
            creationCompanyUser: "Company/User Creation",
            evaluations: "Evaluations",
            officeScheduling: "Office Scheduling",
            queueManagement: "Queue Management",
            companyManagement: "Company Management",
            connectionManagement: "Connection Management",
            sendGreetingAccepted: "Send Greeting on Accepting Ticket",
            sendMsgTransfTicket:
              "Send Transfer Message between Departments/Agents",
            checkMsgIsGroup: "Ignore Group Messages",
            chatBotType: "Bot Type",
            userRandom: "Random Agent Selection",
            buttons: "Buttons",
            acceptCallWhatsapp: "Notify that WhatsApp call is not accepted?",
            sendSignMessage: "Allow agent to choose to send Signature",
            sendGreetingMessageOneQueues:
              "Send Greeting when only one queue exists",
            sendQueuePosition: "Send Queue Position Message",
            sendFarewellWaitingTicket: "Send Farewell Message while Waiting",
            acceptAudioMessageContact:
              "Accept Audio Messages from All Contacts?",
            enableLGPD: "Enable LGPD Processing",
            requiredTag: "Required Tag to Close Ticket",
            closeTicketOnTransfer:
              "Close Ticket when Transferring to Another Queue",
            DirectTicketsToWallets: "Automatically Move Client to Wallet",
            showNotificationPending: "Show Notification for Pending Tickets",
          },
          customMessages: {
            sendQueuePositionMessage: "Queue Position Message",
            AcceptCallWhatsappMessage: "Message to Inform Call Not Accepted",
            greetingAcceptedMessage: "Greeting Message When Accepting Ticket",
            transferMessage:
              "Transfer Message - ${queue.name} = destination queue",
          },
          LGPD: {
            title: "LGPD",
            welcome: "Welcome Message (LGPD)",
            linkLGPD: "Privacy Policy Link",
            obfuscateMessageDelete: "Obfuscate Deleted Message",
            alwaysConsent: "Always Request Consent",
            obfuscatePhoneUser: "Obfuscate User Phone Number",
            enabled: "Enabled",
            disabled: "Disabled",
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Assigned to:",
          dialogRatingTitle:
            "Would you like to leave a service rating for the client?",
          dialogClosingTitle: "Closing the service with the client!",
          dialogRatingCancel: "Resolve WITH Farewell Message",
          dialogRatingSuccess: "Resolve and Send Rating",
          dialogRatingWithoutFarewellMsg: "Resolve WITHOUT Farewell Message",
          ratingTitle: "Choose a rating menu",
          notMessage: "No message selected",
          amount: "Prospecting Value",
          buttons: {
            return: "Return",
            resolve: "Resolve",
            reopen: "Reopen",
            accept: "Accept",
            rating: "Send Rating",
            enableIntegration: "Enable Integration",
            disableIntegration: "Disable Integration",
            logTicket: "Ticket Logs",
            requiredTag: "You must assign a tag before closing the ticket.",
            greetingAcceptedMessage:
              "You must configure a greeting message when accepting the ticket.",
            newTicket: "Create New Ticket",
          },
        },
      },
      messagesInput: {
        placeholderPrivateMessage:
          "Type a message or press / for quick replies",
        placeholderOpen: "Type a message or press / for quick replies",
        placeholderClosed: "Reopen or accept this ticket to send a message.",
        placeholderPending: "Type your internal message (ticket pending)...",
        signMessage: "Sign",
        privateMessage: "Private Message",
      },
      contactDrawer: {
        header: "Contact Details",
        buttons: {
          edit: "Edit Contact",
          block: "Block",
          unblock: "Unblock",
        },
        extraInfo: "Additional Information",
      },
      messageVariablesPicker: {
        label: "Available Variables",
        vars: {
          contactFirstName: "First Name",
          contactName: "Name",
          user: "Agent",
          greeting: "Greeting",
          protocolNumber: "Protocol Number",
          date: "Date",
          hour: "Hour",
          ticket_id: "Ticket Number",
          queue: "Sector",
          connection: "Connection",
        },
      },
      ticketOptionsMenu: {
        schedule: "Schedule",
        delete: "Delete",
        transfer: "Transfer",
        registerAppointment: "Contact Notes",
        resolveWithNoFarewell: "Resolve without Farewell",
        acceptAudioMessage: "Accept audio messages from contact?",
        appointmentsModal: {
          title: "Ticket Notes",
          textarea: "Note",
          placeholder: "Enter the information you want to register here",
        },
        confirmationModal: {
          title: "Delete the contact's ticket",
          titleFrom: "from contact",
          message:
            "Attention! All messages related to this ticket will be lost.",
        },
        buttons: {
          delete: "Delete",
          cancel: "Cancel",
        },
      },
      messageInput: {
        windowExpiredPlaceholder: "⚠️ 24h window expired - Recommended to send a template",
        windowExpiredBanner: "24h Window Expired:",
        windowExpiredBannerDetail: "We recommend sending a template, but you can also type normally.",
        tooltip: {
          signature: "Enable/Disable Signature",
          privateMessage: "Enable/Disable Private Message",
          meet: "Send video conference link",
          triggerFlow: "Trigger Flow",
        },
        type: {
          imageVideo: "Photos and Videos",
          cam: "Camera",
          contact: "Contact",
          meet: "Video Call",
          template: "Meta Template",
        },
        pendingAlert: {
          title: "Ticket Pending:",
          description: "Only internal messages are allowed at this time.",
        },
        flowAlert: {
          title: "Flow Running:",
          description: "Message field temporarily disabled.",
        },
        formatMenu: {
          bold: "Bold",
          italic: "Italic",
          strikethrough: "Strikethrough",
          code: "Code",
          numberedList: "Numbered List",
          bulletList: "Bulleted List",
          quote: "Quote",
          clearFormat: "Clear Formatting",
        },
        ghostMention: {
          tooltip: "Ghost Mention (notifies everyone without showing @)",
          label: "Ghost Mention",
        },
        signature: {
          label: "Signature",
        },
        comments: {
          tooltip: "Enable/Disable Comments",
          label: "Comments",
        },
        quickAnswers: {
          hintNavigate: "{{count}} replies • use ↑↓ to navigate",
          hintScroll: "{{count}} replies • scroll for more",
        },
        errors: {
          ticketIdNotFound: "Error: Ticket ID not found",
        },
        internalMessageLabel: "Internal Message",
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancel",
        },
      },
      messageOptionsMenu: {
        delete: "Delete",
        reply: "Reply",
        edit: "Edit",
        forward: "Forward",
        toForward: "Forward",
        talkTo: "Talk To",
        confirmationModal: {
          title: "Delete message?",
          message: "This action cannot be undone.",
        },
      },
      invoices: {
        table: {
          invoices: "Invoices",
          details: "Details",
          users: "Users",
          connections: "Connections",
          queue: "Queues",
          value: "Value",
          expirationDate: "Expiration Date",
          action: "Action",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP:
          "There must be at lest one default WhatsApp connection.",
        ERR_NO_DEF_WAPP_FOUND:
          "No default WhatsApp found. Check connections page.",
        ERR_WAPP_NOT_INITIALIZED:
          "This WhatsApp session is not initialized. Check connections page.",
        ERR_WAPP_CHECK_CONTACT:
          "Could not check WhatsApp contact. Check connections page.",
        ERR_WAPP_INVALID_CONTACT: "This is not a valid whatsapp number.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Could not download media from WhatsApp. Check connections page.",
        ERR_INVALID_CREDENTIALS: "Authentication error. Please try again.",
        ERR_SENDING_WAPP_MSG:
          "Error sending WhatsApp message. Check connections page.",
        ERR_DELETE_WAPP_MSG: "Couldn't delete message from WhatsApp.",
        ERR_OTHER_OPEN_TICKET:
          "There's already an open ticket for this contact.",
        ERR_SESSION_EXPIRED: "Session expired. Please login.",
        ERR_USER_CREATION_DISABLED:
          "User creation was disabled by administrator.",
        ERR_NO_PERMISSION: "You don't have permission to access this resource.",
        ERR_DUPLICATED_CONTACT: "A contact with this number already exists.",
        ERR_NO_SETTING_FOUND: "No setting found with this ID.",
        ERR_NO_CONTACT_FOUND: "No contact found with this ID.",
        ERR_NO_TICKET_FOUND: "No ticket found with this ID.",
        ERR_NO_USER_FOUND: "No user found with this ID.",
        ERR_NO_WAPP_FOUND: "No WhatsApp found with this ID.",
        ERR_CREATING_MESSAGE: "Error while creating message on database.",
        ERR_CREATING_TICKET: "Error while creating ticket on database.",
        ERR_FETCH_WAPP_MSG:
          "Error fetching the message in WhtasApp, maybe it is too old.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "This color is already in use, pick another one.",
        ERR_WAPP_GREETING_REQUIRED:
          "Greeting message is required if there is more than one queue.",
        ERR_OUT_OF_HOURS: "Outside Business Hours!",
      },
      messagesAPIInstructions: {
        endpoint: "Endpoint:",
        method: "Method:",
        post: "POST",
        headers: "Headers:",
        headerAuthorization:
          "Authorization Bearer (registered token) and Content-Type (application/json)",
        body: "Body:",
        fieldNumber: '"number": "558599999999"',
        fieldBody: '"body": "Message"',
        fieldUserId: '"userId": User ID or ""',
        fieldQueueId: '"queueId": Queue ID or ""',
        fieldSendSignature: '"sendSignature": Sign message - true/false',
        fieldCloseTicket: '"closeTicket": Close the ticket - true/false',
        singMessage: "Sign message - true/false",
        closeTicket: "Close the ticket - true/false",
        testSend: "The Test Send",
      },
      recurrenceSection: {
        title: "Recurrence",
        description:
          "You can choose to send the message recurrently and select the interval. If it is a one-time message, do not change anything in this section.",
        labelInterval: "Interval",
        intervalFilterValue: "Interval filter value",
        sendAsManyTimes: " Send as many times",
        shipNormallyOnNonbusinessDays: "Ship normally on non-business days",
        sendOneBusinessDayBefore: "Send one business day before",
        sendOneBusinessDayLater: "Send one business day later",
        options: {
          days: "Days",
          weeks: "Weeks",
          months: "Months",
          minutes: "Minutes",
        },
        servicePanel: {
          allowRealTime: "Service Panel",
        },
      },
      servicePanel: {
        allowRealTime: "Service Panel  ",
      },
      financial: {
        invoices: "Invoices",
        details: "Details",
        users: "Users",
        connections: "Connections",
        queues: "Queues",
        value: "Value",
        expirationDate: "Due Date",
        status: "Status",
        action: "Action",
      },
      statusFilter: {
        statusFilter: "Filter by Status",
      },
      momentsUser: {
        services: "Services:",
        pending: "Pending",
        noqueue: "NO QUEUE",
      },
      campaignsPhrase: {
        campaignsFlow: "Campaigns Flow",
        campaigns: "Campaign",
        name: "Name",
        status: "Status",
        newCampaignWithFlowByPhrase: "New campaign with flow by phrase",
        editCampaignWithFlowByPhrase: "Edit campaign with flow by phrase",
        phraseTriggerName: "Phrase trigger name",
        chooseAStream: "Choose a stream",
        whichPhraseTriggersTheFlow: " Which phrase triggers the flow?",
        selectAConnection: " Select a Connection",
        cancel: "CANCEL",
        createCampaign: "CREATE CAMPAIGN ",
        saveCampaign: "Save Campaign",
        connections: "Connections",
        newCampaign: "New Campaign",
        nameNotDefined: "Name not defined",
        phrasesConfigured: "{{count}} phrase(s) configured",
        active: "Active",
        inactive: "Inactive",
        editCampaignTooltip: "Edit campaign",
        deleteCampaignTooltip: "Delete campaign",
        noCampaignsFound: "No campaigns found",
        noCampaignsHelper: 'Click "New Campaign" to create your first flow campaign',
        noConnection: "No connection",
        moreConnections: "{{count}} more connection(s)",
        toast: {
          deleted: "Campaign deleted successfully",
          errorLoadingFlows: "Error loading flows",
          errorLoadingConnections: "Error loading connections",
          errorLoadingCampaign: "Error loading campaign data",
          flowNotFound: "Selected flow not found",
          saveError: "Error saving campaign",
          fillRequiredFields: "Please fill in all required fields",
          updated: "Campaign updated successfully!",
          created: "Campaign created successfully!",
        },
        campaignNameLabel: "Campaign name",
        selectFlowLabel: "Select a flow",
        multiple: "(Multiple)",
        whatsappConnectionsLabel: "WhatsApp Connections",
        connectionsSelectedTitle: "{{count}} connection(s) selected:",
        connectionsSelectedDescription: "The campaign will run whenever any of these connections receives messages matching the configured phrases.",
        filterByTag: "Filter by Contact Tag",
        optional: "(optional)",
        filterByTagDescription: "If selected, the flow will only trigger for contacts who have at least one of these tags on the ticket.",
        tagsOptionalLabel: "Tags (optional)",
        tagFilterActive: "🏷️ Active filter: The flow will only trigger for contacts who have at least one of the {{count}} selected tag(s).",
        keywordsTitle: "Keywords that trigger the flow",
        orLogicInfo: "🔀 OR logic: The flow will trigger if the contact sends any of the words/phrases below.",
        exactPartialInfo: "Exact: identical message.  |  Partial: word contained anywhere in the message.",
        or: "OR",
        phraseLabel: "Word/phrase {{index}}",
        phrasePlaceholder: "E.g.: hi, hello, I want a quote...",
        type: "Type",
        exact: "Exact",
        partial: "Partial",
        addPhraseButton: "+ Add another word/phrase (OR)",
        saving: "Saving...",
        validation: {
          nameRequired: "Name is required",
          flowRequired: "Flow is required",
          connectionRequired: "You must select at least one connection",
          fieldRequired: "Required field",
        },
      },
      chatList: {
        noMessages: "No messages",
        admin: "Admin",
        member: "Member",
        searchChat: "Search chat...",
        createNewChat: "Create new chat",
        searchUser: "Search user...",
        noUserFound: "No user found",
        noUserAvailable: "No user available",
        cancel: "Cancel",
        details: "Details",
        deleteChat: "Delete Chat",
        deleteChatConfirm: "This action cannot be undone, confirm?",
        detailsTitle: "Details",
        edit: "Edit",
        delete: "Delete",
        now: "now",
        minutesAgo: "{{count}}m ago",
        hoursAgo: "{{count}}h ago",
      },
      chatMessages: {
        deleted: "This message was deleted",
        deletedAdmin: "Deleted message - visible only to administrators",
        reply: "Reply",
        edit: "Edit",
        delete: "Delete",
        forward: "Forward",
        editMessage: "Edit Message",
        save: "Save",
        cancel: "Cancel",
        deleteMessage: "Delete Message",
        deleteMessageConfirm: "Are you sure you want to delete this message?",
        forwardMessage: "Forward Message",
        selectChat: "Select chat",
        doubleClickToReply: "Double click to reply",
        edited: "(edited)",
        forwarded: "(forwarded)",
        typeMessage: "Type a message...",
        send: "Send",
        noMessages: "No messages",
        loading: "Loading...",
        replyingTo: "Replying to",
        clickToGoToOriginal: "Click to go to original message",
      },
      chatPopover: {
        reply: "Reply",
        edit: "Edit",
        delete: "Delete",
        forward: "Forward",
        cancel: "Cancel",
        confirmDelete: "Confirm Delete",
        confirm: "Confirm",
        deleteMessage: "Are you sure you want to delete this message?",
        editMessage: "Edit Message",
        save: "Save",
        forwardMessage: "Forward Message",
        selectChat: "Select chat",
        forward: "Forward",
        noChats: "No chat available",
      },
      chatIndex: {
        chats: "Chats",
        groups: "Groups",
        new: "New",
        messages: "Messages",
        search: "Search...",
        noChats: "No chat found",
        noGroups: "No group found",
        noMessages: "No messages",
        loading: "Loading...",
        error: "Error loading data",
        addGroupPhoto: "Add Group Photo",
        changeGroupPhoto: "Change Group Photo",
        groupName: "Group Name",
        groupDescription: "Group Description",
        save: "Save",
        cancel: "Cancel",
        createGroup: "Create Group",
        editGroup: "Edit Group",
        deleteGroup: "Delete Group",
        deleteGroupConfirm: "Are you sure you want to delete this group?",
        edit: "Edit",
        delete: "Delete",
        details: "Details",
        groupDetails: "Group Details",
        title: "Title",
        description: "Description",
        modal: {
          title: "Create Group",
          editTitle: "Edit Group",
          save: "Save",
          cancel: "Cancel",
          name: "Group Name",
          description: "Group Description",
          create: "Create",
          edit: "Edit",
        },
      },
      whitelabel: {
        primaryColorLight: "Primary Color (Light Theme)",
        primaryColorDark: "Primary Color (Dark Theme)",
        appName: "Application Name",
        logoLight: "Logo (Light Theme)",
        logoDark: "Logo (Dark Theme)",
        favicon: "Favicon",
        backgroundLight: "Background Image (Light Theme)",
        backgroundDark: "Background Image (Dark Theme)",
        preview: "Preview",
        delete: "Delete",
        upload: "Upload",
        availableLanguages: "Available Languages",
        atLeastOneLanguage: "At least one language must be enabled",

        sections: {
          general: "General Settings",
          generalDescription: "Configure the application name and basic information",
          colors: "Colors and Themes",
          colorsDescription: "Customize primary colors for light and dark themes",
          logos: "Logos and Images",
          logosDescription: "Upload application logos and background images",
          languages: "Available Languages",
          languagesDescription: "Select which languages will be available in the system"
        }
      }
    },
    whatsappModalRel: {
      form: {
        isOficial: "Support Report",
        ticketId: "Ticket ID",
        client: "Customer",
        number: "Number",
        agent: "Agent",
        date: "Date",
        lastMessage: "Last Message",
        fullReport: "The full report is attached above",
        resolveAndTriggerIntegration: "Resolve and Trigger Integration",
        elementNotFoundForExport: "Element not found for export.",
        reportFilename: "support_report",
      },
    },
  },
};

export { messages };
